<template>
  <div class="home-page">
    <!-- 活動標題與介紹區塊 -->
    <div class="div-centerY ActiveAllInfo">
      <div v-if="isPC" class="ActiveTitle">{{ eventData.name }}</div>
      <div v-else class="ActiveTitle PC div-center" v-html="eventData.name"></div>
      <div class="ActiveInfoDiv oneLine">
        <div class="ActivePic">
          <img class="pic" :src="eventData.bannerImage || defaultBanner" alt="">
        </div>
        <div class="titleContentArea">
          <div class="otherInfoArea">
            <p>
              本活動參考了
              <a class="a_color" href="https://cirn.moe.edu.tw/WebContent/index.aspx?sid=1199&mid=14127"
                target="_blank">PISA</a>、
              <a class="a_color" href="https://cirn.moe.edu.tw/Module/index.aspx?sid=1201" target="_blank">PIRLS</a>
              等級的素養文本，並結合專家設計命題，呈現多元且有趣的閱讀素養題型，激發學生的學習興趣。<br>
              <br>
              透過HiTeach教學軟體，可以在課堂上更快速、高效地進行閱讀測驗，讓師生親身體驗科技融入教學的優勢，同時提升生生用平板的應用成效。<br>
              <br>
              歡迎各班級踴躍參與，共同探索學習新體驗！
              <br>
            </p>
            <div class="Replenish" v-if="eventData.disclaimer">{{ eventData.disclaimer }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 按鈕區塊 -->
    <div class="oneLine div-center">
      <div :class="['joinButtonArea', !isPC && 'div-center']" v-if="eventData.introUrl">
        <div :class="['joinButton', 'downLoad', 'load', 'whiteColor', 'div-center', isPC && 'PC']">
          <a :href="eventData.introUrl" target="_blank">
            <div class="txt" style="color:white;">
              活動簡介與說明
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </a>
        </div>
      </div>
      <div class="joinButtonArea" v-if="!isSignUpClosed && !isTeacherJoinBlocked && (!isUserLoggedIn || (!isJoin && !shouldHideJoinEntry))"
        @click="BtnFunction('join')">
        <div
          :class="['joinButton', 'whiteColor', 'div-center', ((ActiveStart && PageStatus===0) ? 'onClick' : ''), 'mar-right', isPC && 'PC']">
          <div class="txt" translate="no">
            {{ isPreSignUp ? "我要預報名" : "我要報名" }}
            <el-icon>
              <ArrowRightBold />
            </el-icon>
          </div>
        </div>
      </div>
      <div class="joinButtonArea" v-if="isUserLoggedIn && (isJoin || shouldHideJoinEntry)" @click="BtnFunction('edit')">
        <div :class="['joinButton', 'whiteColor', 'div-center', 'mar-right', isPC && 'PC']">
          <div class="txt" translate="no">
            新增/管理報名班級
            <el-icon>
              <ArrowRightBold />
            </el-icon>
          </div>
        </div>
      </div>
      <div :class="['joinButtonArea', !isPC && 'div-center']" v-if="isReviewer && eventData.features?.allowReviewer">
        <div :class="['joinButton', 'downLoad', 'load', 'whiteColor', 'div-center', isPC && 'PC']">
          <a href='javascript:void(0)' @click="gotoTeammodel('%2Fhome%2FhtExamMark')">
            <div class="txt" style="color:white;">
              評審閱卷
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- 已報名班級區塊 -->
    <div class="div-center">
      <div class="cotentDiv oneLine">
        <div :class="isPC ? 'tableDiv class left' : 'tableDiv left'"
          v-if="isJoin && (classListCtrl || PageStatus !== 0)">
          <div class="dialog-header">
            <span class="title_school" style="margin-left: auto;margin-right: auto;">{{ enrolledSchoolInfo.schoolName
              }}</span>
          </div>
          <div class="between titleDiv">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/other_books.png" alt="">
              已報名班級：
            </div>
            <span class="spanTotal2" v-show="isPC">合計{{ selectedCoursesCount }}班， 預估{{ totalExpStuNum }}人，已有{{
              totalStudents }}人</span>
            <span style="width: 30%;"></span>
            <div class="picButton" @click="BtnFunction('edit')"
              v-if="PageStatus === 1 || (PageStatus === 2 && applyInfoData.length > 0)" v-show="isPC">
              <img class="buttonImg" src="../../assets/img/area-01.png" alt="">
              <div class="pngText div-centerY">
                新增/管理報名班級
              </div>
            </div>
          </div>

          <div v-if="!isPC">
            <!-- 手機版已報名班級列表 -->
            <div class="PhoneArea" v-for="(data, i) in applyInfoData" :key="i">
              <div class="left">
                <span class="title">{{ data.group }}</span>
              </div>
              <div class="between">
                <div class="left">
                  <span style="margin-right:20px">{{ data.course }}</span>
                  <span>{{ data.class }}</span>
                </div>
                <div class="left">
                  <span style="margin-right:20px">人數：{{ data.students }}</span>
                </div>
              </div>
              <div v-if="PageStatus === 2" class="left">
                <div class="stressColor">{{ data.stage }}</div>
              </div>
              <div class="line" v-if="i !== (applyInfoData.length - 1)"></div>
            </div>
          </div>
          <div v-else class="tableArea">
            <!-- 電腦版已報名班級表格 -->
            <table class="scheduleTable">
              <thead>
                <tr>
                  <th>組別</th>
                  <th>班級</th>
                  <th>預估人數</th>
                  <th>實際人數</th>
                  <th v-if="PageStatus === 2">進行階段</th>
                  <th v-if="PageStatus === 2"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in applyInfoData" :key="index">
                  <td>{{ row.group }}</td>
                  <td>{{ row.course }} - {{ row.class }}</td>
                  <td>{{ row.expStuNum }}</td>
                  <td>{{ row.students }}</td>
                  <td v-if="PageStatus === 2">
                    <div class="stressColor">{{ row.stage }}</div>
                  </td>
                  <td v-if="PageStatus === 2" style="text-align: center;">
                    <div @click="gotoTeammodel('%2Fhome%2FprivExam')" class="otheBlueColor" style="cursor: pointer;">
                      詳細數據
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 得獎名單區塊 - 活動結束後才顯示 -->
    <div class="div-center" v-if="isAwardRevealed && eventData.awards?.length > 0">
      <div class="cotentDiv oneLine">
        <div class="tableDiv right">
          <div class="titleDiv winArea oneLine">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/awards_medal.png" alt="">
              得獎名單：
            </div>
          </div>

          <!-- 電腦版得獎名單 -->
          <div v-if="isPC">
            <div v-if="eventData.awardNotice" style="text-align: left;">
              <div v-html="eventData.awardNotice"></div>
            </div>
            <div :class="i === 0 ? 'winCotent div-centerY' : 'winCotent div-centerY'"
              v-for="(group, i) in eventData.awards" :key="i">
              <div class="ContestTitle isPc oneLine">{{ group.title }}</div>
              <div class="tableCss">
                <el-table :data="group.data">
                  <el-table-column prop="rank" label="排名" width="180">
                    <template #default="scope">
                      <div class="oneLine">
                        <img v-if="scope.row.rank === '1'" class="iconPic"
                          src="../../assets/img/awards/awards_trophy1.png" alt="">
                        <img v-else-if="scope.row.rank === '2'" class="iconPic"
                          src="../../assets/img/awards/awards_trophy2.png" alt="">
                        <img v-else-if="scope.row.rank === '3'" class="iconPic"
                          src="../../assets/img/awards/awards_trophy3.png" alt="">
                        <img v-else-if="scope.row.rank === 'excellent'" class="iconPic"
                          src="../../assets/img/awards/awards_decoration1.png" alt="">
                        <img v-else-if="scope.row.rank === 'Shortlisted'" class="iconPic"
                          src="../../assets/img/awards/awards_decoration2.png" alt="">
                        <span class="otheBlueColor winTxt" v-if="scope.row.rank === '1'">第一名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === '2'">第二名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === '3'">第三名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === 'excellent'">優秀獎</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === 'Shortlisted'">入圍獎</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="school" label="學校" />
                  <el-table-column prop="class" label="班級名稱" width="200" />
                  <el-table-column prop="TName" label="帶隊教師" width="100">
                    <template #default="scope">
                      <div class="otheBlueColor">{{ scope.row.TName }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>

          <!-- 手機版得獎名單 -->
          <div v-else>
            <div v-if="eventData.awardNotice" style="text-align: left;">
              <div v-html="eventData.awardNotice"></div>
            </div>
            <div :class="i === 0 ? 'winCotent div-centerY' : 'winCotent div-centerY'"
              v-for="(group, i) in eventData.awards" :key="i">
              <div class="ContestTitle oneLine">{{ group.title }}</div>
              <div v-for="(item, k) in group.data" :key="k" class="tableCssPhone">
                <div class="Div1 between">
                  <div class="oneLine div-centerY2">
                    <img v-if="item.rank === '1'" class="iconPic" src="../../assets/img/awards/awards_trophy1.png"
                      alt="">
                    <img v-else-if="item.rank === '2'" class="iconPic" src="../../assets/img/awards/awards_trophy2.png"
                      alt="">
                    <img v-else-if="item.rank === '3'" class="iconPic" src="../../assets/img/awards/awards_trophy3.png"
                      alt="">
                    <img v-else-if="item.rank === 'excellent'" class="iconPic"
                      src="../../assets/img/awards/awards_decoration1.png" alt="">
                    <img v-else-if="item.rank === 'Shortlisted'" class="iconPic"
                      src="../../assets/img/awards/awards_decoration2.png" alt="">
                    <span class="otheBlueColor winTxt" v-if="item.rank === '1'">第一名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === '2'">第二名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === '3'">第三名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === 'excellent'">優秀獎</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === 'Shortlisted'">入圍獎</span>
                  </div>
                  <div class="Div2">
                    <div class="left">{{ item.school }}</div>
                    <div class="left">
                      <span class="gray1Color rightSet">{{ item.class }}</span>
                      <span class="otheBlueColor">{{ item.TName }}</span>
                    </div>
                  </div>
                </div>
                <p class="line"></p>
              </div>
            </div>
          </div>
        </div>

        <!-- 優選學校區塊 - 活動結束後才顯示 -->
        <div class="tableDiv right" v-if="eventData.excellentSchools?.length > 0">
          <div class="titleDiv between">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/awards_trophies.png" alt="">
              {{ eventData.excellentSchoolsTitle || '優選學校' }}：
            </div>
          </div>
          <div class="schoolList" :style="isPC ? 'margin-left: 30px' : ''">
            <div class="list" v-for="(school, index) in eventData.excellentSchools" :key="index">
              <img class="iconPic" :src="getStarIcon(index)" alt="">
              {{ school }}
              <img class="iconPic" :src="getStarIcon(index)" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表單填寫提醒 - 活動結束後才顯示 -->
    <div v-if="isAwardRevealed && eventData.formUrl" class="div-center" style="width: 100%; margin-top: 50px;">
      <div v-if="isPC" class="award-form-notice-pc">
        <div style="font-size: 25px; font-weight: 700; margin-bottom: 20px">
          {{ eventData.formTitle || '請得獎教師務必填寫此表' }} <br /><br />
          <span class="form-link-decoration">📝</span>
          <a :href="eventData.formUrl" style="color: #2d8cf0;" target="_blank">表單連結</a>
          <br /><br />
          <span v-if="eventData.formDeadline">*請於 {{ eventData.formDeadline }} 前回填完此表單，以利活動後續作業</span>
        </div>
      </div>
      <div v-else class="award-form-notice-mobile"
        style="width: 80%; height: 300px; margin-left: 10%; margin-right: 10%;">
        <div class="mobile-notice-text">
          {{ eventData.formTitle || '請得獎教師務必填寫此表' }} <br /><br />
          <span class="form-link-decoration">📝</span>
          <a :href="eventData.formUrl" style="color: #2d8cf0;" target="_blank">表單連結</a>
          <br /><br />
          <div class="deadline-notice" v-if="eventData.formDeadline">
            *請於 {{ eventData.formDeadline }} 前回填完此表單
          </div>
        </div>
      </div>
    </div>

    <!-- 重要時程區塊 -->
    <div class="div-center" style="margin-bottom: 20px;">
      <div class="cotentDiv oneLine">
        <div class="tableDiv right">
          <div class="titleDiv between">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/other_book.png" alt="">
              重要時程：
            </div>
          </div>

          <!-- 手機版時程 -->
          <div v-if="!isPC">
            <div v-for="(data, i) in PlanData" :key="i" class="scheduleArea">
              <div class="between titleArea">
                <div class="oneLine titleSet">
                  <div><span class="otheBlueColor stepName">{{ data.stepName }}</span></div>
                  <div class="current_progress" v-if="data.isNow">※目前活動進度</div>
                </div>
                <div style="font-size: 20px;" v-if="isJoin && PageStatus !== 0">
                  <a :href="data.url" target="_blank" v-if="data.urlOpen && data.url !== ''">
                    <el-icon>
                      <Download />
                    </el-icon>
                  </a>
                </div>
              </div>
              <div class="card">
                <div class="between place">
                  <div>地點：<span v-html="data.location"></span></div>
                </div>
                <div class="between time" style="color:#999">
                  <div>{{ data.startTime }} ~ {{ data.endTime }}</div>
                </div>
                <div class="description" v-html="data.description"></div>
              </div>
              <div class="triangleArea div-center" v-if="i !== (PlanData.length - 1)">
                <div>
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 電腦版時程表格 -->
          <div class="tableArea" v-else>
            <table class="scheduleTable">
              <thead>
                <tr>
                  <th>時程</th>
                  <th :style="{ width: isNarrow ? 'auto' : '150px' }">階段</th>
                  <th :style="{ width: isNarrow ? 'auto' : '200px' }">地點</th>
                  <th>說明</th>
                  <th v-if="isJoin && PageStatus !== 0" style="width: 70px;">下載</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in PlanData" :key="index" :class="PlanDataRowClass({ row })">
                  <td>{{ row.startTime }} ~ {{ row.endTime }}</td>
                  <td>
                    <div class="otheBlueColor">{{ row.stepName }}</div>
                    <span v-if="row.isNow" class="current_progress">目前活動進度</span>
                  </td>
                  <td>
                    <div class="info-cell" v-html="row.location"></div>
                  </td>
                  <td>
                    <div class="info-cell" v-html="row.description"></div>
                  </td>
                  <td v-if="isJoin && PageStatus !== 0" style="text-align: center;">
                    <div class="URL" style="font-size: 20px;">
                      <a :href="row.url" target="_blank" v-if="row.urlOpen && row.url !== ''">
                        <el-icon>
                          <Download />
                        </el-icon>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 頁尾單位資訊 -->
    <div :class="isPC ? 'footerDiv div-center' : 'footerDiv phone div-center'">
      <div class="txtDiv">
        <!-- <template v-if="eventData.sponsors.supervisor?.length">
          指導單位：{{ eventData.sponsors.supervisor.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.organizer?.length">
          主辦單位：{{ eventData.sponsors.organizer.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.coOrganizer?.length">
          協辦單位：{{ eventData.sponsors.coOrganizer.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.partner?.length">
          合作單位：{{ eventData.sponsors.partner.join('、') }}<br/>
        </template> -->
      </div>
    </div>

    <!-- ========== 對話框區塊 ========== -->

    <!-- 報名視窗 -->
    <el-dialog v-model="dialogSignUpCtrl" class="applyTableDiv div-centerY signup-dialog  create-class-dialog"
      width="40%" top="6vh" style="height: 675px">
      <template #header>
        <div class="dialog-header class-dialog-full-underline class-create-dialog-header">
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title">報名活動</span>
        </div>
      </template>
      <div class="signup-form-wrap">
        <!-- 步驟 1：確認報名資訊 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">1</span> 確認報名資訊</div>
          <div class="signup-info-group">
            <div class="signup-field-row">
              <span class="signup-field-label">報名學校</span>
              <span class="signup-field-value">{{ userSchool.schoolName }}</span>
            </div>
            <div class="signup-field-row">
              <span class="signup-field-label">{{ courseListDisplayName }}</span>
              <span class="signup-field-value">{{ selectedRow?.name }}</span>
            </div>
          </div>
        </div>

        <!-- 步驟 2：填寫報名資料 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">2</span> 填寫報名資料</div>
          <div class="form-item">
            <strong>預估人數：</strong>
            <el-input v-model="selectedRow.expStuNum"
              style="width:100%; --el-input-border-color:#999; --el-input-focus-border-color:#999;" />
          </div>
          <div class="form-item">
            <strong>報名組別：</strong>
            <el-cascader v-model="selectedRow.groupId" :options="groupListOption"
              style="width:100%; --el-input-border-color:#999; --el-input-focus-border-color:#999;" />
          </div>
          <div class="form-item" style="margin-bottom:0">
            <strong>Email 填寫/確認：</strong>
            <el-input v-model="signUpEmail"
              style="width:100%; --el-input-border-color:#999; --el-input-focus-border-color:#999;" />
            <div style="font-size:13px; margin-top:8px; color:#666; line-height:1.7;">
              <div>📌 活動通知將會發送到此，務必填寫能接收到通知的信箱</div>
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" v-model="isSaveMainEmail" :disabled="isMustSaveMainEmail" />
                將此 Email 作為帳號的主要聯絡信箱
              </label>
            </div>
          </div>
        </div>

        <!-- Action Bar -->
        <div class="signup-dialog-footer">
          <el-button @click="dialogAddClassConfirm()" round type="primary" size="large">送出報名</el-button>
          <el-button @click="dialogSignUpCtrl = false" round type="danger" size="large">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 登入後提示訊息 -->
    <el-dialog v-model="dialogAfterLoginCtrl" width="25%" top="15vh" class="login-dialog">
      <template #header>
        <div class="login-dialog-header">
          <span class="login-dialog-title">{{ eventData.name }}</span>
        </div>
      </template>
      <div class="login-dialog-content">
        <p>您已登入成功！</p>
        <br>
        <div v-if="!isSignUpClosed && isTeacherJoinBlocked">您不在本活動教師清單中，無法報名此活動。</div>
        <div v-else-if="!isSignUpClosed && !shouldHideJoinEntry">如欲報名活動，請點選 <strong>「<a class="a_color"
              @click="BtnFunction('join')">{{ isPreSignUp ? "我要預報名" : "我要報名" }}</a>」</strong> 進行報名。</div>
        <div v-else-if="!isSignUpClosed && shouldHideJoinEntry">此活動為班級名單模式，請點選「新增/管理報名班級」。</div>
        <div v-else>報名時間已結束。</div>
      </div>
    </el-dialog>

    <!-- 手機版登入提示 -->
    <el-dialog v-model="dialogAfterLoginNoPCCtrl" width="90%" top="15vh" class="login-dialog">
      <template #header>
        <div class="login-dialog-header">
          <span class="login-dialog-title">{{ eventData.name }}</span>
        </div>
      </template>
      <div class="login-dialog-content">
        <div>如欲報名活動，請用網頁進行報名。</div>
      </div>
    </el-dialog>

    <!-- 班級管理對話框 -->
    <el-dialog v-model="dialogAddClassCtrl" class="applyTableDiv div-centerY class-create-dialog" width="60%" top="5vh">
      <template #header>
        <div class="dialog-header">
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title ">參賽班級管理</span>
        </div>
      </template>
      <div class="content div-center2">
        <div class="info">          
          一、HiTeach軟體安裝與基本操作 <a class="urlCss" href="https://www.habook.com/zh-tw/faq.php?act=view&id=274" target="_blank">GO</a>! 
          <br>
          二、建立名單與官網班級報名畫面
          <a class="urlCss" href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#join" target="_blank">GO</a>!          
          <br>
          三、注意事項<br>
          <div style="margin-left: 28px;">
          如老師遇到不確定「新學期所教班級」之狀況，本次活動在報名時，透過簡易名單，可先填寫預計參加的班級、預估人數，做預報名。<br>
          待後續班級名單確認後，再來重新匯入、編輯學生名單皆是可以的，請師長們放心報名參加！
          </div>

          <!-- 3.如果報名後參賽班級有變動(增加或減少學生)，要再回來此處<b><u>更新資料並重新選擇</u></b>喔！ -->
        </div>
        <div class="school-header" style="text-align: center;">
          <span class="title class-manage-school-underline">
            {{ userSchool.schoolName }}
          </span>
        </div>
        <div class="chooseArea2"
          style="display: flex; justify-content: center; flex-direction: column; align-items: center; gap: 15px;">
          <div
            style="display: flex; justify-content: flex-start; gap: 30px; flex-wrap: wrap; width: 100%; align-items: center;">
            <el-button type="primary" v-if="!isSignUpClosed && !isSchoolClassTeacherTargetMode"
              @click="openCreateClass('crt')">新建簡易名單</el-button>
            <span style="color:#E88847; font-size: 15px; font-weight: 600;">已報名班級總數：{{ selectedCoursesCount }}</span>
            <span style="color:#E88847; font-size: 15px; font-weight: 600;">人數：{{ totalStudents }}</span>
            <span style="color:#E88847; font-size: 15px; font-weight: 600;">預估人數：{{ totalExpStuNum }}</span>
          </div>
        </div>
        <!-- 純 HTML 卡片列表（取代 el-table） -->
        <div class="cardListContainer class-manage-card-list" :class="{ 'hide-edit-column': isSchoolClassTarget }">
          <!-- 表頭 -->
          <div class="cardListHeader">
            <div class="cardColumn col-name">{{ courseListDisplayName }}</div>
            <div class="cardColumn col-students">人數</div>
            <div class="cardColumn col-exp-students">預估人數</div>
            <div v-if="!isSchoolClassTarget" class="cardColumn col-edit">編輯</div>
            <div class="cardColumn col-group">組別</div>
            <div class="cardColumn col-action">操作</div>
          </div>

          <!-- 卡片列表 -->
          <div class="cardListBody">
            <div v-for="(row, index) in applyTableData" :key="index" class="cardRow">
              <!-- 課程名稱列 -->
              <div class="cardColumn col-name">
                <span>{{ row.courseName }} - {{ row.name }}</span>
                <span class="highlight-row status-enrolled"
                  v-show="row.groupId.some((id) => id.toString().trim() !== '')">已報名</span>
              </div>
              <!-- 人數列 -->
              <div class="cardColumn col-students">
                <span>{{ row.students }}人</span>
              </div>
              <!-- 預估人數列 -->
              <div class="cardColumn col-exp-students">
                <span>{{ row.expStuNum }}人</span>
              </div>
              <!-- 編輯簡易名單列 -->
              <div v-if="!isSchoolClassTarget" class="cardColumn col-edit">
                <el-button v-if="row.type === 'simple' && !isAfterFinalStage && !isSchoolClassTeacherTargetMode"
                  type="warning" plain size="small" round @click="openCreateClass('upd', row)">
                  編輯簡易名單
                </el-button>
              </div>
              <!-- 組別列 -->
              <div class="cardColumn col-group">
                <span>{{ getGroupName(row.groupId[0]) }}</span>
              </div>
              <!-- 操作列 -->
              <div class="cardColumn col-action">
                <button v-show="row.groupId[0] !== '' && !isAfterFinalStage" class="btn btn-secondary btn-action-edit"
                  @click="openSelectItem(row)">
                  編輯
                </button>
                <button v-if="row.groupId[0] !== '' && !isAfterFinalStage" class="btn btn-danger btn-action-cancel" @click="cancelConfirm(row)">
                  取消
                </button>
                <button v-else-if="!isSignUpClosed && !isTeacherJoinBlocked" class="btn btn-primary btn-action-signup"
                  @click="openSelectItem(row)">
                  報名
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 新增/變更班級對話框 -->
    <el-dialog v-model="dialogCreateClassCtrl" class="applyTableDiv div-centerY create-class-dialog" style="width: 40%;"
      top="2vh">
      <template #header>
        <div class="dialog-header class-dialog-full-underline class-create-dialog-header">
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title">新增/變更參賽班級名單</span>
        </div>
      </template>
      <div class="content div-center2">
        <!-- 步驟 1：填寫班級名稱 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">1</span> 填寫班級名稱</div>
          <div class="school-header">
            <div class="createClass-name-row">
              <span class="createClass-course-tag">{{ courseName }}</span>
              <span class="createClass-dash">—</span>
              <el-input v-model="grouplistName" placeholder="請輸入班級名稱，例如：一年一班"
                style="flex:1; max-width:280px; --el-input-border-color:#999999; --el-input-focus-border-color:#999999; --el-input-bg-color:#fff; font-size:15px;" />
            </div>
          </div>
        </div>

        <!-- 步驟 2：輸入學生名單 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">2</span> 輸入學生名單</div>
          <div class="info">
            <div class="createClass-hint-body">
              <div class="createClass-hint-text">
                <div>📋 格式：<strong>名字,座號</strong>，每行一位；💡 可直接從 Excel 複製兩欄資料貼上</div>
              </div>
              <div class="createClass-hint-img">
                <img src="./../../assets/img/2024091301.jpg" class="hint-img-zoom"
                  style="max-width:90px; border-radius:6px; border:1px solid #a9cce3;" />
              </div>
            </div>
          </div>
          <div class="createClass-editor">
            <div class="createClass-editor-col">
              <div class="createClass-col-label">貼上名單</div>
              <el-input type="textarea" v-model="studentInput" placeholder="大雄,1
胖虎,2
小夫,3" rows="7" style="width:100%; --el-input-border-color:#999999; --el-input-focus-border-color:#999999;" />
            </div>
            <div class="createClass-editor-arrow">
              <button class="btn btn-primary createClass-add-btn" @click="addStudents">加入 →</button>
            </div>
            <div class="createClass-editor-col">
              <div class="createClass-col-label">確認名單（{{ students.length }} 人）</div>
              <el-table :data="students" border
                style="width:100%; --el-table-border-color:#999999; --el-border-color:#999999;" max-height="200"
                empty-text="尚無學生">
                <el-table-column prop="name" label="名字" />
                <el-table-column prop="seat" label="座號" width="70" />
                <el-table-column label="" width="60">
                  <template #default="scope">
                    <div style="display:flex; justify-content:center;">
                      <el-button type="danger" size="small" @click="deleteStudent(scope.$index)">刪除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 步驟 3：確認送出 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">3</span> 確認送出</div>
          <div class="chooseArea2" style="text-align:center; padding: 16px;">
            <el-button type="primary" size="large" @click="submitCourse">確定新增/變更</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- Loading 狀態 -->
    <div v-if="isLoading" class="loading-overlay">
      <el-icon class="is-loading" :size="50">
        <Loading />
      </el-icon>
      <p>載入活動資料中...</p>
    </div>

  </div>
</template>


<script setup>
import { ref,computed,reactive,onMounted,onUnmounted,inject,watch,defineProps,markRaw   } from 'vue';//inject,reactive,ref,computed,h
//import { useRouter } from 'vue-router';
import { ElMessage,ElMessageBox } from 'element-plus';//ElMessageBox, 
import profile from "../../api/profile";
import {Base64} from 'js-base64'
import api from "@/api";
import jwtDecode from 'jwt-decode'
// 引入國家/地區資料的 JSON 檔案，包含國家、城市的代碼與名稱對應關係
import country_v2 from '@/static/regions/country_v2.json'
import { Delete } from '@element-plus/icons-vue'

// 由app.vue傳進來的參數 活動資料
const props = defineProps(["blobEventDataJson"]);

// 監聽app.vue傳進來的參數 做動作
watch(() => props.blobEventDataJson, async (newData) => {
  // console.log("apiData 變更了！ oldData", oldData);
  // console.log("apiData 變更了！ newData", newData);
  if(newData){
    await setLoginInfo();//先檢查是否需要登入作業
    if (sessionStorage.getItem("id_token")) {// 檢查有無登入資料,並拿tmdid
    let t_data = jwtDecode(sessionStorage.getItem("id_token"));
    tmdid.value = t_data.sub;
    ecName.value = sessionStorage.getItem("open_name");
    ecEmail.value = sessionStorage.getItem("open_mail");

    //判斷是否可以看決賽地點。
    FractionData.forEach(element => {
      element.data.forEach(temp => {
        if (tmdid.value === temp.tmid) localRead.value = true;
      });
    });    

    await getIes5dataFun();//取得老師課程的IES資料[優先於getPlanDataFun()，因為 signUpClassOptions 要先拿，下方資料才能塞]
    await getPlanDataFun();//取得活動的相關資料
    await getActiveData();//取得已報名統測教師課程及組別(需在getPlanDataFun()之後，因為需要 groupListInfo 的資料)

    // 登入後，若無報名資料，且報名時間未結束，則跳出提示訊息
    if (applyInfoData.length === 0 && sessionStorage.getItem("id_token") && isPC.value && ActiveStart.value && PageStatus.value===0 && !isSignUpClosed.value) {
      dialogAfterLoginCtrl.value = true
    }
    
    await setJointData();// 設定報名用表格資料
    
  } else {
    await getPlanDataFun();//取得活動的相關資料
  }
  }
}, { immediate: false });

// 取得 `App.vue` 提供的函式
const updateUserInfo = inject("updateUserInfo");

// 選中欲報名的row
let selectedRow = ref(null);

// 動態生成文件 URL 並進行編碼
//const fileUrl = `/files/${encodeURI("全國好小子熱身練習試卷.htex")}`;
//const fileUrl = `/files/${encodeURI("test.htex")}`;
//const fileUrl = `/files/${encodeURI("fileName.pdf")}`;


let isPreSignUp = ref(false);//是否為預報名階段
let isMustSaveMainEmail = ref(false);//是否必須存mail
let isSaveMainEmail = ref(false);//是否將此Email作為帳號的主要聯絡信箱
let signUpEmail = ref("");//報名用Email
let userSchoolRowData = reactive({});//API取得的使用者學校資料
let userSchool = ref({});//頁面上設定及使用的使用者學校資料
let enrolledSchoolInfo = ref({});//已報名的學校資料
let selectedSchool = ref('');//選擇的學校
let optionsSchool = reactive([]);//學校下拉選單
let isReviewer = ref(false);//是否是評審
// let webID = reactive({ test:'a97e8b54-127c-4b11-bb8d-df5a9f36cfbf',Official:'a97e8b54-127c-4b11-bb8d-df5a9f36cfbf'});
// let ActivityID= ref('a97e8b54-127c-4b11-bb8d-df5a9f36cfbf');
let webID = reactive({ test:'42d9f87e-ea32-4513-a361-c89e0dacb6bc',Official:'42d9f87e-ea32-4513-a361-c89e0dacb6bc'});
let ActivityID= ref('42d9f87e-ea32-4513-a361-c89e0dacb6bc');
let testWebList = ref(['localhost','community-test']);//測試站的網站名單
let isTestWeb = ref(false);//是否是正式站
let ActiveStart=ref(false);//活動是否開始，用 schedule的type=join判斷
let PageStatus = ref(0);//0我要報名，1已經報名，2活動開跑(不能編輯班級)
let isJoin = ref(false);//判斷是否報名
/* ※↑↑若要看PageStatus為2階段，記得把 applyInfoData 內容解註解 */

let tmdid = ref('');//TMID
let ecName = ref('');//使用者名稱
let ecEmail = ref('');//使用者email
let scope = ref('');//個人/學校 "private":個人 "school":學校
let isPC = ref(true);//判斷是否是PC
let localRead = ref(false);//判斷是否有可以看到決賽地點的權限
let upsertMemberMode = ref('');//判斷新建班級或更新班級成員 "crt":新建 "upd":更新
let groupIdSelected = ref('');//選擇中的groupId
let signUpClassSelected = ref('');//選擇中的班級
const originalStudents = ref({});//儲存原始學生資料，用於比對ID
//let search = ref('');


const t = inject('$t');//三國語系

const serverLocation = "global";// 國際站設定
const clientID = profile.clientID[serverLocation];// clientID設定
import { post } from "@/api/http";
import router from '../../router';
const coreAPIUrl = profile.apiUrl[serverLocation];// API路由設定

let FractionData = reactive([
  {
    title: '低年級組',
    data: [
      { rank: '1', school: '高雄市前金國小', TName: '吳婕鳳', tmid: '', class: '一年二班' },
      { rank: '2', school: '高雄市前金國小', TName: '廖敏娟', tmid: '', class: '二年四班' },
      { rank: '3', school: '高雄市前金國小', TName: '許文華', tmid: '', class: '一年三班' },
      { rank: 'excellent', school: '高雄市前金國小', TName: '陳美靜', tmid: '', class: '一年一班' },
      { rank: 'excellent', school: '南投縣爽文國小', TName: '郭月琴', tmid: '', class: '二年甲班' },
      { rank: 'excellent', school: '桃園市元生國小', TName: '謝老師', tmid: '', class: '二年三班' },
      { rank: 'excellent', school: '彰化縣管嶼國小', TName: '尤幸弘', tmid: '', class: '二年二班' },
      { rank: 'excellent', school: '高雄市中山國小', TName: '陳子蕎', tmid: '', class: '二年三班' },
      { rank: 'excellent', school: '南投縣北投國小', TName: '林玉玫', tmid: '', class: '二年甲班' },
      { rank: 'Shortlisted', school: '臺南市後港國小', TName: '林倖儀', tmid: '', class: '二年一班' },
      { rank: 'Shortlisted', school: '南投縣北投國小', TName: '林玉玫', tmid: '', class: '二年乙班' },
      { rank: 'Shortlisted', school: '高雄市前金國小', TName: '林明君', tmid: '', class: '二年一班' },
      { rank: 'Shortlisted', school: '高雄市前金國小', TName: '林明君', tmid: '', class: '二年三班' },      
      { rank: 'Shortlisted', school: '臺北市大學附小', TName: '鄭芳怡', tmid: '', class: '一年八班' },
      { rank: 'Shortlisted', school: '高雄市前金國小', TName: '林明君', tmid: '', class: '二年二班' },
      { rank: 'Shortlisted', school: '新北市新店國小', TName: '江明慧', tmid: '', class: '二年三班' },
      { rank: 'Shortlisted', school: '桃園市龍星國小', TName: '陳健達', tmid: '', class: '二年一班' }
    ]
  },
  {
    title: '中年級組',
    data: [
      { rank: '1', school: '桃園市大華國小', TName: '何世甯', tmid: '', class: '四年一班' },
      { rank: '2', school: '高雄市前金國小', TName: '王珮楹', tmid: '', class: '三年十一班' },
      { rank: '3', school: '高雄市前金國小', TName: '黃姿蓉', tmid: '', class: '四年四班' },
      { rank: 'excellent', school: '高雄市前金國小', TName: '邱千芬', tmid: '', class: '三年四班' },
      { rank: 'excellent', school: '高雄市楠陽國小', TName: '余彗鍹', tmid: '', class: '三年六班' },
      { rank: 'excellent', school: '南投縣水尾國小', TName: '陳宜妏', tmid: '', class: '四年甲班' },
      { rank: 'excellent', school: '高雄市前金國小', TName: '吳孟玲', tmid: '', class: '四年十一班' },
      { rank: 'excellent', school: '新北市麗林國小', TName: '宋挺美', tmid: '', class: '四年十一班' },
      { rank: 'excellent', school: '高雄市前金國小', TName: '吳佩芳', tmid: '', class: '三年三班' },
      { rank: 'Shortlisted', school: '臺中市臺中教大附小', TName: '陳慧如', tmid: '', class: '三年戊班' },
      { rank: 'Shortlisted', school: '澎湖縣馬公國小', TName: '林鈺珅', tmid: '', class: '五年舞蹈班' },
      { rank: 'Shortlisted', school: '臺北市志清國小', TName: '沈佩蓉', tmid: '', class: '四年四班' },
      { rank: 'Shortlisted', school: '臺北市志清國小', TName: '夏靜雯', tmid: '', class: '四年三班' },
      { rank: 'Shortlisted', school: '新北市瓜山國小', TName: '李青祐', tmid: '', class: '四年忠班' },
      { rank: 'Shortlisted', school: '臺南市新民國小', TName: '李佩燕 陳玥蓓', tmid: '', class: '四年三班' },
      { rank: 'Shortlisted', school: '屏東縣仁愛國小', TName: '黃偉菖', tmid: '', class: '三年七班' },
      { rank: 'Shortlisted', school: '臺北市南港國小', TName: '楊汶潔', tmid: '', class: '四年六班' },
      { rank: 'Shortlisted', school: '新北市秀朗國小', TName: '陶怡蒨', tmid: '', class: '三年五班' }
    ]
  },
  {
    title: '高年級組',
    data: [
      { rank: '1', school: '臺中市樹義國小', TName: '段菀翠', tmid: '', class: '五年一班' },
      { rank: '2', school: '雲林縣鎮南國小', TName: '劉文尚', tmid: '', class: '六年一班' },
      { rank: '3', school: '澎湖縣文光國小', TName: '郭訓豪', tmid: '', class: '六年一班' },
      { rank: 'excellent', school: '臺北市明德國小', TName: '花梅真', tmid: '', class: '六年二班' },
      { rank: 'excellent', school: '新北市中和國小', TName: '林麗足', tmid: '', class: '五年十班' },
      { rank: 'excellent', school: '高雄市新興國小', TName: '張晏榕', tmid: '', class: '六年二班' },      
      { rank: 'excellent', school: '屏東縣仁愛國小', TName: '李孟芳', tmid: '', class: '六年六班' },
      { rank: 'excellent', school: '臺南市佳里國小', TName: '黃鈺婷', tmid: '', class: '六年四班' },
      { rank: 'Shortlisted', school: '桃園市仁和國小', TName: '辛老師', tmid: '', class: '六年三班' },
      { rank: 'Shortlisted', school: '桃園市仁和國小', TName: '蕭涵之', tmid: '', class: '六年一班' },
      { rank: 'Shortlisted', school: '臺北市志清國小', TName: '徐慧鈴', tmid: '', class: '六年五班' },
      { rank: 'Shortlisted', school: '臺南市臺南大學附小', TName: '古佳潔', tmid: '', class: '六年己班' },
      { rank: 'Shortlisted', school: '臺東縣臺東大學附小', TName: '李鎔而', tmid: '', class: '六年一班' },
      { rank: 'Shortlisted', school: '臺北市博嘉實驗國小', TName: '鄭惠文', tmid: '', class: '五年一班' },
      { rank: 'Shortlisted', school: '雲林縣石榴國小', TName: '張見芳', tmid: '', class: '五年丙班' },
      { rank: 'Shortlisted', school: '新竹縣博愛國小', TName: '徐藍思', tmid: '', class: '六年信班' },
      { rank: 'Shortlisted', school: '臺南市開元國小', TName: '許惠淨', tmid: '', class: '五年三班' }
    ]
  },
  {
    title: '國中組',
    data: [
      { rank: '1', school: '南投縣三光國中', TName: '蕭秀緞', tmid: '', class: '九年一班' },
      { rank: '1', school: '嘉義縣義竹國中', TName: '謝淑媚', tmid: '', class: '九年三班' },
      { rank: '2', school: '新北市忠孝國中', TName: '林佳樺', tmid: '', class: '九年五班' },
      { rank: '3', school: '臺北市中崙高中', TName: '陳蕙瑤', tmid: '', class: '八年三班' },
      { rank: 'excellent', school: '新北市忠孝國中', TName: '林佳樺', tmid: '', class: '九年四班' },
      { rank: 'excellent', school: '嘉義縣義竹國中', TName: '龔寶仁', tmid: '', class: '九年一班' },
      { rank: 'excellent', school: '臺北市中崙高中', TName: '陳蕙瑤', tmid: '', class: '八年一班' },
      { rank: 'excellent', school: '新北市忠孝國中', TName: '林佳樺', tmid: '', class: '九年二班' },
      { rank: 'excellent', school: '臺北市信義國中', TName: '簡怡美', tmid: '', class: '七年四班' },
      { rank: 'excellent', school: '臺北市百齡高中', TName: '黃于珊', tmid: '', class: '八年二班' },
      { rank: 'Shortlisted', school: '新北市忠孝國中', TName: '林佳樺', tmid: '', class: '九年三班' },
      { rank: 'Shortlisted', school: '新北市忠孝國中', TName: '林佳樺', tmid: '', class: '九年十班' },
      { rank: 'Shortlisted', school: '嘉義縣義竹國中', TName: '方苡馨', tmid: '', class: '唯五獨尊' },
      { rank: 'Shortlisted', school: '臺北市信義國中', TName: '簡怡美', tmid: '', class: '七年六班' },
      { rank: 'Shortlisted', school: '臺北市信義國中', TName: '簡怡美', tmid: '', class: '七年三班' },
      { rank: 'Shortlisted', school: '花蓮縣壽豐國中', TName: '陳湧昌', tmid: '', class: '八年仁班' },
      { rank: 'Shortlisted', school: '臺北市麗山國中', TName: '陳品翰', tmid: '', class: '七年八班' },
      { rank: 'Shortlisted', school: '臺北市信義國中', TName: '簡怡美', tmid: '', class: '七年九班' },
      { rank: 'Shortlisted', school: '臺北市信義國中', TName: '簡怡美', tmid: '', class: '七年二班' }
    ]
  }
]);//得獎相關

let groupListInfo = [//報名組別
  // {name:'國小低年級組',testID:'55edeec3-a3cd-4117-b2e1-4e10c5b3d651',OfficialID:'a6504df5-9850-4ad5-abd2-0ac01b340d5c'},
  // {name:'國小中年級組',testID:'06361f08-5108-464e-ba93-317e4c0248fd',OfficialID:'e753ae2d-0a32-4232-999d-092b8e965c82'},
  // {name:'國小高年級組',testID:'d1409e4c-b0d0-45dd-ad94-3fe2fd89d9d6',OfficialID:'767337ef-7de6-4485-ba7e-ddd2cc317e07'},
  // {name:'國中',testID:'0394efdd-9a97-460d-b77f-6f66307c1d5d',OfficialID:'d735d171-05f3-4501-a303-a66b566de8fa'},
];
let groupListOption = []

let dialogSignUpCtrl = ref(false);
let dialogAfterLoginCtrl = ref(false);
let dialogAfterLoginNoPCCtrl = ref(false);
let dialogSetSchoolCtrl = ref(false);
let dialogAddClassCtrl = ref(false);
let classListCtrl= ref(false);
let dialogCreateClassCtrl = ref(false);
let isSignUpSubmitting = ref(false);//報名送出中，避免重複送出

const courseName = ref('')// 課程名稱
const grouplistName = ref('')// 班級名稱
const studentInput = ref('')
const students = ref([])

// eslint-disable-next-line no-unused-vars
const getGoodkidUrl = computed(() => {
  return window.location.origin + "/goodkid";
});

// ========================設定學校下拉選單相關 Start========================
const rawData = ref(country_v2);//地區資料
// 建立 `el-cascader` 選單數據
const cascaderOptions = computed(() => {
    const country = rawData.value.find((item) => item.t === "c");

    if (!country) return [];

    return [
      {
        label: country.cN,
        value: country.c,
        children: rawData.value
          .filter((item) => item.t === "y")
          .map((city) => ({
            label: city.yN,
            value: city.y            
          }))
      }
    ];
  });
// el-cascader 配置
// eslint-disable-next-line no-unused-vars
const cascaderProps = {
    expandTrigger: "hover",
    value: "value",
    label: "label",
    children: "children"
  };
// 存放選擇的值
const selectedLocation = ref([]);
// 當選擇變更時觸發
// eslint-disable-next-line no-unused-vars
const handleLocationChange = (value) => {
  console.log("選擇的地區:", value);
  // let headers = {
  //   headers: {
  //     'Content-Type': 'application/json',
  //     'Authorization': tokens.token_type + ' ' + tokens.access_token
  //   }
  // }
  if(value){
    selectedSchool.value = "";
    let data = {
      countryId: value[0],
      cityId: value[1]
    }
    post(coreAPIUrl + '/service/schoolData', data).then(res => {
      optionsSchool.length = 0;
      res.forEach((item) => {
        optionsSchool.push(item)
      })
      //resolve(res)
    }, err => {
      console.log("API error", err);
    })
  }else{
    optionsSchool.length = 0;
    selectedSchool.value = "";
  }
  
};
// ========================設定學校下拉選單相關 end========================


// 選擇報名總數
const selectedCoursesCount = computed(() => {
  return signUpGroupOptions.reduce((groupTotal, group) => {
    return groupTotal + group.signUpClassData.reduce((classTotal, signUpClass) => {
      return classTotal + signUpClass.course.filter(course => course.selected).length;
    }, 0);
  }, 0);
});

const totalStudents = computed(() => {
  return applyTableData.value
    .filter(item => item.groupId.some(id => id.trim() !== "")) // 篩選 groupId 有值的項目
    .reduce((sum, item) => sum + item.students, 0); // 計算 students 總和
});

const totalExpStuNum = computed(() => {
  return applyTableData.value
    .filter(item => item.groupId.some(id => id.trim() !== "")) // 篩選 groupId 有值的項目
    .reduce((sum, item) => sum + item.expStuNum, 0); // 計算 預估人數 總和
});

// 判斷報名是否已結束
const isSignUpClosed = computed(() => {
  const now = new Date().getTime();
  // 找到報名或預報名階段，只有在時間窗口內（startTime ~ endTime）才視為「可報名」
  for (const step of PlanData) {
    if (step.stepName.includes("報名")) {
      const stepStartTime = parseInt(step.stepStartTime);
      const stepEndTime = parseInt(step.stepEndTime);
      // 在報名時間窗口內 → 未關閉
      if (now >= stepStartTime && now <= stepEndTime) {
        return false;
      }
    }
  }
  // 沒有找到進行中的報名階段（未開始或已結束）→ 關閉
  return true;
});

// 判斷是否已進入「班級熱身賽」階段或之後
// eslint-disable-next-line no-unused-vars
const isAfterWarmUpStage = computed(() => {
  const now = new Date().getTime();
  
  // 找到「班級熱身賽」階段的索引
  let warmUpStageIndex = -1;
  for (let i = 0; i < PlanData.length; i++) {
    if (PlanData[i].stepName.includes("熱身賽") || PlanData[i].stepName.includes("班級熱身賽")) {
      warmUpStageIndex = i;
      break;
    }
  }
  
  // 如果沒有找到熱身賽階段，返回 false
  if (warmUpStageIndex === -1) return false;
  
  // 檢查是否已經進入熱身賽階段（包含）或之後的階段
  for (let i = warmUpStageIndex; i < PlanData.length; i++) {
    const stepStartTime = parseInt(PlanData[i].stepStartTime);
    if (now >= stepStartTime) {
      return true;
    }
  }
  
  return false;
});

//src路徑
// function srcUrl(index){
//   index += 1 ;
//   if(index>8)index = 0;
//   return require(`../../assets/img/symbol/symbol_arrow_0${index}.png`);
// }

//得獎相關↑↑-------------------------------


//重要時程內容↓↓-------------------------------

//重要日程資料
let PlanData = reactive([])

const PlanDataRowClass = ({ row }) => {
  if (row.isNow) {
    return 'tableBackground';
  }  
  return '';
};

const Now_plan = ref('');//當前進度名稱
let blobEventData = reactive({});//當前活動資訊
const eventData = blobEventData;


async function getPlanDataFun() {//取得活動資訊  
  PlanData.splice(0, PlanData.length);
  // 用app.vue 取得的活動資料做設定
  Object.assign(blobEventData, JSON.parse(props.blobEventDataJson))
  // 時程資料處理
  blobEventData.schedule.forEach((item, index) => {
    //props.blobEventData.schedule.forEach((item, index) => {
    let pItem = {
      id: item.id,
      step: index + 1,
      stepStartTime: item.startTime,//程式判斷時間 測試時間  1723564800   活動時間 1725854400000
      stepEndTime: item.endTime,//程式判斷時間 1727539199999
      startTime: formatTaiwanDate(item.startTime),//顯示開始時間
      endTime: formatTaiwanDate(item.endTime),//顯示結束時間 9/28 23:59:59:999
      stepName: item.name,
      location: item.location,
      description: item.description.replace(/\n/g, "<br>"),// 換行符處理
      blobsName: '',//下載檔案名稱
      url: '',//下載檔案連結
      urlOpen: false,//是否提供下載(要判斷兩日前)
      isNow: false,
    }
    PlanData.push(pItem)
  })
  // 組別資料處理     
  blobEventData.groups.forEach((item) => {
    //  props.blobEventData.groups.forEach((item) => {
    let gItem = {
      name: item.name,
      id: item.id
    }
    groupListInfo.push(gItem)
  })

  //取得重要時程資料
  for (let step = 0; step < PlanData.length; step++) {
    //計算是否是兩天前
    let now = new Date().getTime();    
    const stepStartTime = parseInt(PlanData[step].stepStartTime);
    const stepEndTime = parseInt(PlanData[step].stepEndTime);
    const twoDaysLater = stepStartTime - 2 * 24 * 60 * 60 * 1000;
    PlanData[step].urlOpen = (now >= twoDaysLater) ? true : false;//是否開放下載  
    if (step >= 0 && now >= stepStartTime) ActiveStart.value = true; //確認活動是否開始
    if (step >= 2 && now >= stepStartTime) PageStatus.value = 2;//狀態改為活動開跑
    if (now >= stepStartTime && now <= stepEndTime) {
      PlanData[step].isNow = true;
      Now_plan.value = PlanData[step].id;
      if(PlanData[step].stepName === "預報名") {
        isPreSignUp.value = true;
      }
    }
  }
  // 檢查是否有評審資格   //到時候要打開並修改API  因為評審不用登入就可以看 
  // if (ActivityID.value) {
  //   let data = { jointEventId: ActivityID.value };
  //   let res = await api.main.getJointEventFind(data);
  //   if (res && (res.status !== 401) && res.data.length > 0 && res.data[0].groups) {
  //     let groups = res.data[0].groups;//組別
  //     for (let i = 0; i < groups.length; i++) {
  //       if (groups[i].assistants.find(item => item === tmdid.value)) {
  //         isReviewer.value = true;
  //         break;
  //       }
  //     }
  //   }
  // }
    
}

// function openCreateClass(mode, groupId, groupName, courseName) { //顯示編輯班級成員視窗
function openCreateClass(mode, scopeRow) { //顯示編輯班級成員視窗
    courseName.value = "HiTeach"; // 預設課程名稱
    grouplistName.value = "";
    studentInput.value = "";
    students.value = [];
    groupIdSelected.value = "";    
    upsertMemberMode.value = mode;
    
    // 清空原始學生資料
    originalStudents.value = {};
    
    if (mode == 'upd') { //變更編輯成員
    signUpClassSelected.value = scopeRow.id;
        groupIdSelected.value = scopeRow.id;
        courseName.value = scopeRow.courseName;
        grouplistName.value = scopeRow.name;
        let data = { grant_type: 'private', stulist_id: scopeRow.id };
        api.main.getStudentsList(data).then(function (result) {
            if (result.students.length > 0) {
                result.students.forEach(function (s) {
                    let name = (s.name != null && s.name !== "") ? s.name : (s.nickname != null && s.nickname !== "") ? s.nickname : "";
                    let dataRow = name + "," + s.no + "\n";
                    studentInput.value += dataRow;
                    
                    // 儲存原始學生資料到元件內的 ref
                    if (s.id) {
                        // 使用 `${name.trim()}_${s.no.trim()}` 作為 key
                        const key = `${name.trim()}_${s.no.trim()}`;
                        originalStudents.value[key] = s;
                    }
                });
            }
            addStudents();
            dialogCreateClassCtrl.value = true;
        });
    }
    else { //新增班級
        dialogCreateClassCtrl.value = true;
    }
}
watch(studentInput, (newValue) => {
  studentInput.value = newValue.replace(/\t/g, ",");
});
// 添加學生方法
const addStudents = () => {
    students.value = []; //清空學生列表
    const lines = studentInput.value.split('\n')
    const newStudents = []
    for (const line of lines) {
      //const [name, seat] = line.split(',')
      if (line && line !== "") {

        // 每行按逗号或Tab字符分割，获得名字和座号
        const [name, seat] = line.split(/[\t,]/);
        // 檢查座號為數字
        if(/^\d+$/.test(seat) === false){
          ElMessage.error("格式錯誤，請檢查名字及座號欄位是否正確")
          return;
        }

        // 座號重複檢查
        if (newStudents.some(student => student.seat === seat)) {
            ElMessage.error(`姓名: ${name} 座號: ${seat} 已經存在！`)
          continue;
        }        
        newStudents.push({
          name: name,
          seat: seat
        })
      }
    }
    students.value.push(...newStudents)
    //studentInput.value = '' //輸入欄不用清空
  }
  // 删除學生方法
const deleteStudent = (index) => {
    students.value.splice(index, 1)
    ElMessage.success('學生已刪除')
  }
// 送出課程資料
const submitCourse = async () => {
    //新建班級才驗標題
    if (upsertMemberMode.value == 'crt') {
        if (!grouplistName.value || students.value.length === 0) {
            ElMessage.error('請輸入課程名稱並添加學生！')
            return
        }
    }
    
    let members = [];
    students.value.forEach((item) => {
      // 檢查是否有符合的原始學生資料
      let studentId = "";
      // 使用name和no作為key進行比對
      const key = `${item.name.trim()}_${item.seat.trim()}`;
      if (originalStudents.value[key]) {
        studentId = originalStudents.value[key].id || "";
      }
      
      let mitem = {
        id: studentId, // 如果有找到相符的學生，使用原始的id
        code: null,
        type: 3,
        nickname: item.name,
        no: item.seat,
        irs: item.seat
      }
      members.push(mitem);
    });
    let courseId = (upsertMemberMode.value == 'upd') ? signUpClassSelected.value : ""
    let data={
      courseName: courseName.value,
      groupListName: grouplistName.value,
      limitCount: 200,
      courseId: courseId,
      groupId: groupIdSelected.value,
      member: members,      
    };
    let JointCourseData = "";
    if (upsertMemberMode.value == 'crt') {
        JointCourseData = await api.main.setJointCourseUpsertPlus(data); //呼叫新增參賽班級名單API
    }
    else if (upsertMemberMode.value == 'upd') {
        JointCourseData = await api.main.updJointCourseUpsertPlus(data); //變更參賽班級成員API
    }
    
    if (JointCourseData) {
      // 變動前先記錄目前的選項  變動後再設定回去
      //let signUpClassCache = JSON.parse(JSON.stringify(signUpClass.value));  

      await updateDataFun()
      await getActiveData()
      //signUpClass.value = signUpClassCache
      //signUpClassFun(signUpClass.value)
      await setJointData()

      let msg = (upsertMemberMode.value == 'crt') ? '新增參賽班級名單成功！' : '變更參賽班級名單成功！'
      await ElMessage.success(msg)
      if(upsertMemberMode.value === 'crt'){// 如果是新增，則新增完成後直接進入報名狀態         
         let newClassItem = applyTableData.value.find(item => item.id === JointCourseData.groupId)
         openSelectItem(newClassItem)
      }
      dialogCreateClassCtrl.value = false
      students.value.splice(0, students.value.length) //清空表單資料    
      courseName.value = ""
      grouplistName.value = ""
      studentInput.value = ""
    }    
  }

function formatTaiwanDate(timestamp) {//Unix 時間戳轉為"113/09/20 12:00"格式
  const date = new Date(timestamp);
  const year = date.getFullYear() - 1911; // 轉換為民國年
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份需要加 1 並且補零
  const day = date.getDate().toString().padStart(2, '0'); // 日期補零
  const hours = date.getHours().toString().padStart(2, '0'); // 時補零
  const minutes = date.getMinutes().toString().padStart(2, '0'); // 分補零
  return `${year}/${month}/${day} ${hours}:${minutes}`;
}
//重要時程內容↑↑----------------------


//加入班級的的對話框相關資訊↓↓------------------------------------------------------
//參加名單的表格資料↓↓
// let stageTxtArry = ref(['(尚未開始)','(進行中)','(已完成，已具備決賽資格)','(未晉級)']);
// let stageTxtArry = ref(['(進行中)','(進行中)','(已完成)','(未晉級)']);
// let stageTxtArry2 = ref(['(未完成，活動已結束)','(未完成，活動已結束)','(已完成)','(未晉級，活動已結束)']);
let applyInfoData = reactive([//表格資料 
]);
//參加名單的表格資料↑↑

//加入班級資訊↓↓
let signUpGroup = ref([]);//報名組別
const signUpGroupOptions = reactive([]);
const signUpGroupFun = (value) => {//報名組別下拉選單function
  const group = signUpGroupOptions.find(item => item.value === value.toString());

  // 抓取對應的報名組別的  班級課程/名單(小宇宙) 組  
  signUpClassOptionsShow.splice(0, signUpClassOptionsShow.length);
  group.signUpClassData.forEach(item => {
    signUpClassOptionsShow.push(item);
  });  
}

let signUpClassOptionsShow  = reactive([]);//班級課程下拉選單data專門顯示用
const signUpClassOptions = reactive([]);

async function getActiveData(){//取得已報名的統測教師課程及組別  
  if(!ActivityID.value && !tmdid.value)return;
  applyInfoData.splice(0,applyInfoData.length)
  signUpGroupOptions.splice(0,signUpGroupOptions.length)
  //取得活動組別資料
  const groupName = 'Group';
  let runCount = 0;  
  for(let element of groupListInfo){//<<<須改  groupListInfo
    runCount++;
    const signUpClassData = JSON.parse(JSON.stringify(signUpClassOptions));
    // if(isTestWeb.value)signUpGroupOptions.push({value:groupName+runCount,label:element.name,GroupId:element.testID,signUpClassData:signUpClassData});
    // else signUpGroupOptions.push({value:groupName+runCount,label:element.name,GroupId:element.OfficialID,signUpClassData:signUpClassData});
    signUpGroupOptions.push({
      value:groupName+runCount, 
      label:element.name, 
      GroupId:element.id, 
      signUpClassData:signUpClassData
      });        
  }

  //取得統測老師資料
  let joinType = isPreSignUp.value ? "pre" : "regular"; 

  let data={
    jointEventId:ActivityID.value,
    creatorId: tmdid.value,
    type:joinType
  };
  let JointCourseData = await api.main.getJointCourseFind(data);     
  if(JointCourseData && JointCourseData.data && JointCourseData.data.length!==0){//若有報名資料，則繼續往下處理
    isJoin.value = true;//有報名
    if(PageStatus.value===0)PageStatus.value = 1;//改到已經報名的階段
    JointCourseData = JointCourseData.data;
    // 設定頁面上要顯示的學校資訊
    enrolledSchoolInfo.value = {
      schoolId : JointCourseData[0].schoolId,
      schoolName : JointCourseData[0].schoolName    
    }
    
    JointCourseData.forEach(res => {
      signUpGroupOptions.forEach(group => {//確認報名資訊，並修改報名勾選資料and顯示報名組別的資料
        let Data_group = '';
        let Data_groupID = '';
        let Data_course = '';  
        let Data_courseID = '';    
        let Data_class = '';
        let Data_classID = '';
        if (group.GroupId === res.jointGroupId ) {
          Data_group = group.label;
          Data_groupID = group.GroupId;
          group.signUpClassData.forEach(classData => {
            res.courseLists.forEach(course => {
              if (classData.id === course.courseId) {
                Data_course = classData.label;
                Data_courseID = classData.id;
                course.groupLists.forEach(groupList => {
                  classData.course.forEach(courseDetail => {
                    if (courseDetail.id === groupList.id) {
                      Data_class = courseDetail.name;
                      Data_classID = courseDetail.id;
                      courseDetail.selected = true;
                      courseDetail.expStuNum = groupList.expStuNum;
                      let stageData = '';
                      if(Now_plan.value!==''){
                        stageData = groupList.schedule.find(item => item.id === Now_plan.value);
                      }
                      else {//假設時間在數據期間，則顯示上一筆。
                        let planData = getCurrentPlanData();
                        stageData = groupList.schedule.find(item => item.id === planData.id);
                      }
                      if(!stageData){
                        stageData = {name:"",status:"",id:""}
                      }
                      applyInfoData.push({//加入報名班級資訊
                        group: Data_group , groupID:Data_groupID,
                        course: Data_course ,courseID:Data_courseID,
                        class: Data_class,  classID:Data_classID,
                        stage: (stageData!=''? stageData.name : ''), 
                        stageID:(stageData!='' ? stageData.id: ''),
                        stageStatus:stageData.status,//進行狀況 "undo" "doing" "complete" "disqualify" //
                        students: courseDetail.students,
                        expStuNum: courseDetail.expStuNum
                      });
                    }
                  });
                });
              }
            });
          });
        }
      });
    });
  }
}

function getCurrentPlanData() {
  const now = new Date().getTime(); // 當前時間戳
  let currentPlan = PlanData[PlanData.length - 1]; // 預設為最後一筆資料

  for (let i = 0; i < PlanData.length; i++) {
    const stepStartTime = parseInt(PlanData[i].stepStartTime); // 開始時間
    const stepEndTime = parseInt(PlanData[i].stepEndTime); // 結束時間

    // 判斷當前時間是否介於這筆資料的開始和結束時間之間
    if (now >= stepStartTime && now <= stepEndTime) {
      currentPlan = PlanData[i];
      break; // 找到符合條件的資料，跳出循環
    } else if (i > 0 && now < stepStartTime) {
      // 如果超過上一筆資料結束時間且在這筆資料開始時間之前，顯示上一筆資料
      currentPlan = PlanData[i - 1];
      break;
    }
  }
  return currentPlan; // 回傳當前符合條件的計劃資料
}

const applyTableData = ref([]);
async function getIes5dataFun(){//取得老師課程的相關資料
  let data={tmid: tmdid.value};
  let res = await api.main.getIesTeacherCourse(data);
  if(res && (res.status === 200))res = res.data;
  const gradeName = 'Grade';
  let runCount = 0;
  for(let element of res){//接『班級課程』資料
    runCount++;
    scope.value = element.courseBase.scope;//個人/學校 "private":個人 "school":學校
    let course = reactive([]);
    if(element.courseTasks.length>0){      
      for(let data of element.courseTasks[0].schedules){//接『名單』資料
        course.push({name:data.groupName,id:data.groupId, type:data.type,students:data.memberCount ,selected: false, expStuNum:0});       
      }       
    }
    signUpClassOptions.push({
      value:gradeName+runCount,
      label:element.courseBase.name,
      id:element.courseBase.id,
      course:course}); 
  }
}

//更新資料
async function updateDataFun(){
  //signUpClass.value = [];//清空下拉組別
  applyTableData.value = [];//清空班級課程

  //重新取得活動組別資料
  signUpClassOptions.length = 0;//清空
  await getIes5dataFun();//取得老師課程的IES資料
  signUpGroupOptions.length = 0;//清空
  const groupName = 'Group';
  let runCount = 0;  
  for(let element of groupListInfo){
    runCount++;
    const signUpClassData = JSON.parse(JSON.stringify(signUpClassOptions));
    signUpGroupOptions.push({value:groupName+runCount,label:element.name,GroupId:element.id,signUpClassData:signUpClassData})  
  }
  if(signUpGroup.value.length>0)signUpGroupFun(signUpGroup.value);  
}

async function dialogAddClassConfirm(rowItem){//確認   
  if (!rowItem && isSignUpSubmitting.value) return;
  if (!rowItem) {
    isSignUpSubmitting.value = true;
  }

  try {
if(rowItem){
  // 取消流程
   // 找到選中的項目並修改值    
    rowItem.expStuNum = 0
    rowItem.groupId[0] = ""   
}else{
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //報名流程
  if(selectedRow.value.expStuNum === "" || selectedRow.value.expStuNum === 0 ){
    ElMessage({
      type: 'error',
      message: '請輸入預估人數！',
    })
    return 
  }else if(selectedRow.value.groupId[0] === "" ){
    ElMessage({
      type: 'error',
      message: '請選擇『報名組別』！',
    })
    return  
  }else if (!signUpEmail.value) {    
    ElMessage({
      type: 'error',
      message: '請輸入 Email！',
    })
    return
  } else if (!emailPattern.test(signUpEmail.value)) {   
    ElMessage({
      type: 'error',
      message: '請輸入有效的 Email 格式！',
    })
    return
  } else {
    // 找到選中的項目並修改值
    let selectItem = applyTableData.value.find(item => item.id === selectedRow.value.id)
    if(selectItem){
      selectItem.expStuNum = parseInt( selectedRow.value.expStuNum)
      selectItem.groupId[0] = selectedRow.value.groupId[0]      
    }else{
      return
    }       
  }
}
if(userSchool.value.mail === "" || isSaveMainEmail.value ){
  // 如果進階資訊沒有email 或是 有勾選將此Email作為帳號的主要聯絡信箱  就必須回寫進階資訊   
  let data = {
    name : sessionStorage.getItem("open_name"),
    grant_type: "add",
    id_token: sessionStorage.getItem("id_token"),
    lang: "zh-tw",
    schoolCode: userSchool.value.schoolId,
    unitType: userSchool.value.schoolUnitType,
    unitName: userSchool.value.schoolName,
    mail: signUpEmail.value.trim()
  }

  post(coreAPIUrl + '/oauth2/Contact', data).then(async res => {
    if (res && res.status && res.status === 200) { 
      console.log("API success", res);
    }else{
      console.log("API error", res);
      return
    }
  })

}
  // 更新 selected 屬性的方法

  // 先清除原本的全部選項
  signUpGroupOptions.forEach((group) => {
      group.signUpClassData.forEach((classData) => {
        classData.course.forEach((course) => {
          course.selected = false; // 將 selected 設為 false
        });
      });
    })
  
  // 處理 signUpGroupOptions 把 applyTableData groupId有值的轉移過去
  applyTableData.value.forEach((item1) => {    
    signUpGroupOptions.forEach((group) => {
      if (group.GroupId === item1.groupId[0]) {
        // 先比對groupId  相符才進入下一層
        group.signUpClassData.forEach((classData) => {
          classData.course.forEach((course) => {
            if (course.id === item1.id) {
              course.selected = true;              
              course.expStuNum = item1.expStuNum;
            }
          });
        });
      }
    });
  });

  //確認名單至少選一個
  // const chooseCount = countSelectedItems(signUpGroupOptions);  
  // if(!chooseCount){//如果沒有選擇任何名單
  //   ElMessage({
  //     type: 'error',
  //     message: '請選擇『名單』！',
  //   });
  //   return;
  // }
  
  classListCtrl.value = true;//開啟報名班級的顯示

  if(PageStatus.value===0 && !isJoin.value){//如果在報名階段 
    PageStatus.value = 1;//成為已報名的階段
    isJoin.value = true;//已經報名
    //寄送EMAIL
    // let sentEmailData = {
    //   type:"join", //寄送類型 ※join:報名成功  
    //   mail:ecEmail.value, //ecEmail.value 'ruby29922026@gmail.com'
    //   name:ecName.value
    // }
    //await api.main.ActivitySentEmail(sentEmailData);
    if (!isPreSignUp.value && !window.location.pathname.includes('goodkid2026_preview')) {// 如果不是預報名才進入授權階段，範例網頁略過

      let coupon = api.main.getCoupon(window.location.pathname)

      if (coupon) {
        let ApplyCouponData = {
          id_token: sessionStorage.getItem("id_token"),
          coupon: coupon
        }
        await post(coreAPIUrl + '/oauth2/ApplyCoupon', ApplyCouponData).then(async res => {      
          if (res && res.message) {
            ElMessage({
              message: "已經報名過該活動",
              type: 'warning',
            })
          }
        });
      }
    }

  }

  //將老師報名資料回報到資料庫
  // applyInfoData.length = 0;//班級更新清空
  let applyInfoDataTemp = reactive([]);//報名班級暫存
  for(let element of signUpGroupOptions){
    const courseLists = element.signUpClassData.reduce((acc, classData) => {
      const selectedCourses = classData.course.filter(course => course.selected);
      if (selectedCourses.length > 0) {
        selectedCourses.forEach(course => {
          acc.push({
            subjectId: null, //科目ID ※預留給學校班級用，個人課程記入null
            courseId: classData.id, //課程ID
            courseName: classData.label, //課程名稱
            groupLists: [{
              id: course.id, //課程名單ID
              name: course.name, //課程名單名稱
              expStuNum: course.expStuNum //預估人數
            }]
          });
        });
      }
      return acc;
    }, []);
    const isFind = applyInfoData.find(item => item.groupID === element.GroupId);
    if(courseLists.length>0 || isFind){      
      let userSchoolId = "";
      let userschoolName = "";
      let schoolCountryId = "";
      let schoolCountryName = "";
      let schoolProvinceId = "";
      let schoolProvinceName = "";
      let schoolCityId = "";
      let schoolCityName = "";
      // 判斷是由教育雲資料還是醍摩豆來的資料報名
      if(sessionStorage.getItem("shortCode")){userSchoolId = sessionStorage.getItem("shortCode")}
      else if(userSchool.value.schoolId){userSchoolId = userSchool.value.schoolId}
      if(sessionStorage.getItem("school_name")){userschoolName = sessionStorage.getItem("school_name")}
      else if(userSchool.value.schoolName){userschoolName = userSchool.value.schoolName}
      if(sessionStorage.getItem("countryId")){schoolCountryId = sessionStorage.getItem("countryId")}
      else if(userSchool.value.schoolCountryId){schoolCountryId = userSchool.value.schoolCountryId}
      if(sessionStorage.getItem("countryName")){schoolCountryName = sessionStorage.getItem("countryName")}
      else if(userSchool.value.schoolCountryName){schoolCountryName = userSchool.value.schoolCountryName}
      if(sessionStorage.getItem("provinceId")){schoolProvinceId = sessionStorage.getItem("provinceId")}
      else if(userSchool.value.schoolProvinceId){schoolProvinceId = userSchool.value.schoolProvinceId}
      if(sessionStorage.getItem("provinceName")){schoolProvinceName = sessionStorage.getItem("provinceName")}
      else if(userSchool.value.schoolProvinceName){schoolProvinceName = userSchool.value.schoolProvinceName}
      if(sessionStorage.getItem("cityId")){schoolCityId = sessionStorage.getItem("cityId")}
      else if(userSchool.value.schoolCityId){schoolCityId = userSchool.value.schoolCityId}
      if(sessionStorage.getItem("region_name")){schoolCityName = sessionStorage.getItem("region_name")}
      else if(userSchool.value.schoolCityName){schoolCityName = userSchool.value.schoolCityName} 
      let joinType = isPreSignUp.value ? "pre" : "regular"; 

      let data={
        jointEventId:ActivityID.value,//活動ID
        jointGroupId:element.GroupId,//組別ID
        creatorId: tmdid.value,//創建者(報名者)TMID
        creatorName :ecName.value,  //創建者名
        creatorEmail:signUpEmail.value.trim(),  //創建者Email
        schoolId: userSchoolId, //[非必須] 學校簡碼 ※無值會記入空字串
        schoolName: userschoolName, //[非必須] 學校名稱 ※無值會記入空字串
        countryId: schoolCountryId,
        countryName: schoolCountryName,
        provinceId: schoolProvinceId,
        provinceName: schoolProvinceName,
        cityId: schoolCityId,
        cityName: schoolCityName,
        type:joinType,//報名類型 "pre":預報名 "regular":正式報名
        scope :scope.value,//個人/學校 "private":個人 "school":學校
        courseLists:courseLists,//課程列表與內部課程資訊      
        };
      
      try {
        let JointCourseData = await api.main.setJointCourseUpsert(data); 
        
        if (!JointCourseData) {
          throw new Error('報名 API 無回應');
        }
        if (JointCourseData.errCode) {
          // errCode 有值（非空字串）→ API 回傳錯誤
          throw new Error(JointCourseData.err || '報名 API 回傳錯誤');
        }

        // errCode === '' 或不存在 → 成功（報名成功時可能只回傳 {"errCode":"","err":""}）
        const upsertCourseLists = JointCourseData?.jointCourse?.courseLists || courseLists;
          // #region 重新取學校資料並設定
            // 取得使用者資料
          let localeProfile = JSON.parse(localStorage.getItem("profile"));
            // 取得學校資料
          let getTmidInfoData = { 
            tmid: localeProfile.id, 
            jointEventId: ActivityID.value
            };
          userSchoolRowData.length = 0;//清空資料
          userSchoolRowData = await api.main.getTmidInfo(getTmidInfoData); 
          
          // 設定頁面上要顯示的學校資訊
          // 如果沒有活動報名資料 就先用使用者資料
          if(userSchoolRowData.joinSchool.length > 0){
              enrolledSchoolInfo.value.schoolId = userSchoolRowData.joinSchool[0].schoolId;
              enrolledSchoolInfo.value.schoolName = userSchoolRowData.joinSchool[0].schoolName;                               
          }else{
              enrolledSchoolInfo.value.schoolId = userSchoolRowData.tmidInfo.schoolCode;
              enrolledSchoolInfo.value.schoolName = userSchoolRowData.tmidInfo.schoolName;          
          }   

          
          setPageSchoolInfo(userSchoolRowData)

          // #endregion
          
          
          //更新報名班級顯示
          if(courseLists.length>0){
            
            for(let CourseData of upsertCourseLists){
              for(let classData of CourseData.groupLists){
                // 找出該班級的學生人數
                let students = element.signUpClassData.flatMap(grade => grade.course).find(course => course.id === classData.id)?.students ?? 0;
                applyInfoDataTemp.push({
                  group: element.label , groupID:element.GroupId,
                  course: CourseData.courseName ,courseID : CourseData.courseId,
                  class: classData.name,  classID: classData.id,
                  expStuNum: classData.expStuNum, //預估人數
                  students: students,

              //   stage:'班級閱讀熱身賽',  stageID:'',
              //   stageStatus:0,//0未完成,1已完成
                });
              }
            }
          }
      } catch (error) {
        console.error('報名失敗:', error);
        ElMessage({
          type: 'error',
          message: '報名失敗，請稍後再試',
        });
        return; // 報名失敗就不繼續執行後續邏輯
      }    }
  }

  // 只有在全部報名 API 成功後才寄送一次 Email，避免信件內容缺少後續組別資料
  if (!rowItem) {
    let sendMail = signUpEmail.value.trim();
    let sendName = "";
    let localeProfile = JSON.parse(localStorage.getItem("profile"));
    if(ecName.value){
      sendName = ecName.value;
    }
    else if(localeProfile && localeProfile.name){
      sendName = localeProfile.name;
    }

    if(sendMail && sendName){
      let joinType = isPreSignUp.value ? "pre" : "regular";
      let sentEmailData = {
        type:"join", //寄送類型 ※join:報名成功
        joinType:joinType,
        mail:sendMail,
        name:sendName,
        creatorId: tmdid.value,
        jointEventId: ActivityID.value,
        courseId: selectedRow.value.courseId,
        groupId: selectedRow.value.id,
      }

      try {
        await api.main.ActivitySentEmail(sentEmailData);
        console.log('Email sent successfully');
      } catch (emailError) {
        console.error('Failed to send email:', emailError);
        // Email 失敗不影響報名成功，只記錄錯誤
      }
    }
  }

  dialogSignUpCtrl.value = false;//關閉報名視窗
  applyInfoData.splice(0, applyInfoData.length, ...applyInfoDataTemp);//更新報名班級顯示。
  if (!rowItem) {
    ElMessage({
      type: 'success',
      message: '報名成功',
    });
  }
  } finally {
    if (!rowItem) {
      isSignUpSubmitting.value = false;
    }
  }
}

// const countSelectedItems = (options) => {//只要有任一個 signUpGroupOptions的 selected = true就回傳true
//   return options.some(group => 
//     group.signUpClassData.some(classData =>
//       classData.course.some(course => course.selected === true)
//     )
//   );
// };

//抓資料看是否是手機
function isMobileBrowser(){
  isPC.value =  sessionStorage.getItem("isPC") === 'true';
}

//加入班級的的對話框相關資訊↑↑------------------------------------------------------



//路由器↓↓
// const routers = useRouter();
// function goToUrl(url){
//   routers.push(url);
// }
//路由器↑↑

//偵測寬度
const isNarrow = ref(false);
const handleResize = () => {
  isNarrow.value = window.innerWidth < 768;
};


onMounted(async () => {    
  window.addEventListener('resize', handleResize);
  handleResize(); // 初始检查窗口宽度
  isMobileBrowser();
  window.addEventListener('resize', isMobileBrowser);

  //判斷stageTxtArry顯示字串
  // const now = new Date().getTime(); // 當前時間戳
  // if(now > 1729764000000)stageTxtArry.value = stageTxtArry2.value;
  //判斷活動ID
    let websitKeyWord = window.location.host;
    let isMatch = testWebList.value.some(keyword => websitKeyWord.includes(keyword));
    if (isMatch) {
      isTestWeb.value = true;
      ActivityID.value = webID.test;//給測試站ID
      // ActivityID.value = webID.Official;//以外為正式站ID
    }
    else ActivityID.value = webID.Official;//以外為正式站ID

  await setLoginInfo()  
   if (localStorage.getItem("profile") && sessionStorage.getItem("access_token")) {
     // 取得使用者資料
     let localeProfile = JSON.parse(localStorage.getItem("profile"));
     // 取得學校資料
     let data = {
       tmid: localeProfile.id,
       jointEventId: ActivityID.value
     };
     userSchoolRowData = await api.main.getTmidInfo(data);
     userSchool.value.mail = userSchoolRowData.tmidInfo.mail;
     // 報名用email先記下來
     signUpEmail.value = userSchoolRowData.tmidInfo.mail;
     // 如果進階資訊沒有email則報名時必須存入
     if (!userSchoolRowData.tmidInfo.mail) {
       isSaveMainEmail.value = true;
       isMustSaveMainEmail.value = true;
     }
     setPageSchoolInfo(userSchoolRowData)
   } 
      
});

// 設定頁面用學校資料
function setPageSchoolInfo(userSchoolRowData){
  if(userSchoolRowData.joinSchool.length > 0){
          userSchool.value.schoolId = userSchoolRowData.joinSchool[0].schoolId;
          userSchool.value.schoolName = userSchoolRowData.joinSchool[0].schoolName;
          userSchool.value.schoolUnitType = userSchoolRowData.joinSchool[0].schoolUnitType;  
          // 透過國家名稱從 country_v2 資料中查找對應的國家代碼
          userSchool.value.schoolCountryId = country_v2.find(item => item.cN === userSchoolRowData.joinSchool[0].schoolCountryName)?.c;
          userSchool.value.schoolCountryName = userSchoolRowData.joinSchool[0].schoolCountryName;
          userSchool.value.schoolProvinceId = "";
          userSchool.value.schoolProvinceName = "";
          // 透過城市名稱從 country_v2 資料中查找對應的城市代碼
          userSchool.value.schoolCityId = country_v2.find(item => item.yN === userSchoolRowData.joinSchool[0].schoolCityName)?.y;
          userSchool.value.schoolCityName = userSchoolRowData.joinSchool[0].schoolCityName;                                
        }else{
          userSchool.value.schoolId = userSchoolRowData.tmidInfo.schoolCode;
          userSchool.value.schoolName = userSchoolRowData.tmidInfo.schoolName;
          userSchool.value.schoolUnitType = userSchoolRowData.tmidInfo.schoolUnitType;
          // 透過國家名稱從 country_v2 資料中查找對應的國家代碼
          userSchool.value.schoolCountryId = country_v2.find(item => item.cN === userSchoolRowData.tmidInfo.schoolCountryName)?.c;
          userSchool.value.schoolCountryName = userSchoolRowData.tmidInfo.schoolCountryName;
          userSchool.value.schoolProvinceId = "";
          userSchool.value.schoolProvinceName = "";
          // 透過城市名稱從 country_v2 資料中查找對應的城市代碼
          userSchool.value.schoolCityId = country_v2.find(item => item.yN === userSchoolRowData.tmidInfo.schoolCityName)?.y;
          userSchool.value.schoolCityName = userSchoolRowData.tmidInfo.schoolCityName;          
        }   
}

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('resize', isMobileBrowser);
  // 清除元件內的學生資料
  originalStudents.value = {};
});

// 設定報名用表格資料
async function setJointData(){
  // 報名列表資料編成        
  const courseMap = new Map();
  signUpGroupOptions.forEach((group) => {
    group.signUpClassData.forEach((classData) => {
      const matchedCourse = signUpClassOptions.find((c) => c.value === classData.value);
      if (!matchedCourse || !matchedCourse.id) return;

      classData.course.forEach((course) => {
        const key = `${matchedCourse.id}-${course.id}`;
        const existing = courseMap.get(key);

        const groupId = course.selected ? [group.GroupId] : [""];
        const newItem = {
          courseName: matchedCourse.label,
          name: course.name,
          groupId,
          courseId: matchedCourse.id,
          id: course.id,
          students: course.students,
          type: course.type,
          expStuNum: course.expStuNum,
        };

        if (!existing || course.selected) {
          courseMap.set(key, newItem);
        }
      });
    });
  });
  // 排序把有選組別的排前面 
  // 判斷是否為中文（根據 Unicode）
  const isChinese = (text) => /[\u4e00-\u9fff]/.test(text);

  applyTableData.value = Array.from(courseMap.values()).sort((a, b) => {
    const aHasGroup = a.groupId.some((id) => id.toString().trim() !== "");
    const bHasGroup = b.groupId.some((id) => id.toString().trim() !== "");

    if (bHasGroup !== aHasGroup) {
      return bHasGroup - aHasGroup; // `groupId` 有值的排前面
    }

    const aIsChinese = isChinese(a.name);
    const bIsChinese = isChinese(b.name);

    if (aIsChinese !== bIsChinese) {
      return aIsChinese - bIsChinese; // 英文優先
    }

    return a.name.localeCompare(b.name, "zh-Hant"); // 中文用筆畫，英文用字母排序
  });
  //applyTableData.value = Array.from(courseMap.values());

  // 組別下拉選單設定
  groupListOption.splice(0, groupListOption.length);
  let gItemFirst = {
    label: "請選擇組別...",
    value: [""]
  }
  groupListOption.push(gItemFirst)
  groupListOption.push(...groupListInfo.map(item => ({ value: item.id, label: item.name })));

  console.log('ActivityID.value', ActivityID.value);

}


async function setLoginInfo(){
  let url = new URL(window.location.href);
  let code = url.searchParams.has("code") == true ? url.searchParams.get("code") : "";
  if (!sessionStorage.getItem("access_token") && code) {
    //登入取得token
    await api.main.getToken().then(async (res) => {
      sessionStorage.setItem("id_token", res.id_token);
      //將access_token存本地, http 攔截器使用
      sessionStorage.setItem("access_token", res.access_token);
      sessionStorage.setItem("expires_in", res.expires_in);
      // 設定使用者資訊
      const decoded = jwtDecode(res.id_token);
      profile.name = decoded.name;
      profile.teammodelId = decoded.sub;
      profile.picture = decoded.picture;
      sessionStorage.setItem("open_name", decoded.name)


      localStorage.setItem(
        "profile",
        JSON.stringify({
          name: profile.name,
          id: profile.teammodelId,
          picture: profile.picture,
        })
      );    

    }).catch((error) => {
        console.log(error);
      });
    // 更新app.vue 使用者資料
    if (updateUserInfo) {
      updateUserInfo()
    }
  }
}

//點選按鈕的function↓↓
async function BtnFunction(val, isFromSetSchool){
  if (!isPC.value) {// 如果不是桌機版不能報名
    dialogAfterLoginNoPCCtrl.value = true
    return;
  }
  
  // 檢查報名是否已結束
  if (val === 'join' && isSignUpClosed.value) {
    ElMessage({
      message: '報名時間已結束，無法進行報名',
      type: 'warning',
      duration: 3000
    });
    return;
  }
  
  // 關閉登入後提示視窗
  dialogAfterLoginCtrl.value = false;

  // 三種進入點
  // 1. 設定學校後進入
  // 2. 點選 "我要預報名":"我要報名" 進入
  // 3. 點選 "新增/管理報名班級" 進入
  if (val === 'join' && !isFromSetSchool) {// 2. 
    if (sessionStorage.getItem("open_name")) { // 有登入
      // 檢查學校資料
      if (( userSchoolRowData.joinSchool.length === 0 && !userSchoolRowData.tmidInfo.schoolCode ) || 
            !userSchool.value.schoolId ) {
        // 沒有設定過學校 跳出視窗給要報名的人填學校
        dialogSetSchoolCtrl.value = true;
      } else {
        signUpTableDataSort()        
      }
    } else { // 沒有登入
      sessionStorage.setItem("info", "test0522");
      if (blobEventData.loginType.includes("tmdId")) {
        if (blobEventData.loginType.includes("eduId")) {
          // 皆可登入
          router.push({ path: '/Activity_CheckLogin', query: { eid: encodeURIComponent(Base64.encode(blobEventData.id)) } });
        } else {
          // 僅可用tmdid登入
          api.main.loginTmdID();
        }
      } else {
        // 其他狀況預設用 eduid登入
        let urlhost = location.host == "localhost:5005" ? "testHT.teammodel.net" : location.host
        let data = {
          client_id: profile.clientID["global"],
          op_redirecturi: "https://" + urlhost + "/Binding_CheckAccount"
        }
        let datastr = encodeURIComponent(Base64.encode(JSON.stringify(data)));
        // let urlhost = location.host == "localhost:5005" ? "testHT.teammodel.net" : location.host
        // let url = "https://oidc.tanet.edu.tw/onesteplogin?Auth_Request_RedirectUri=https://account.teammodel.net/quickopencode/educloudtw/" + profile.clientID["global"] + "?op_redirecturi=" + Base64.encode("https://" + urlhost + "/Binding_CheckAccount") + "&Auth_Request_State=educloudtw&Auth_Request_Response_Type=code&Auth_Request_Client_ID=c58722f58275a8c81fcc5ed6b94f3e7b&Auth_Request_Nonce=aaaaa&Auth_Request_Scope=openid+email+profile+eduinfo&local=true";
        let url = "https://oidc.tanet.edu.tw/oidc/v1/azp?response_type=code&client_id=c58722f58275a8c81fcc5ed6b94f3e7b&redirect_uri=https://account.teammodel.net/&scope=openid+email+profile+eduinfo&state=" + datastr + "&nonce=aaaaa";
        location.href = url;
      }
    }
  } else {
    if(val === "edit"){
      // 3. 要重設學校資料為API取得的
      setPageSchoolInfo(userSchoolRowData)            
    }
    // 1. 3. 共用動作
    signUpTableDataSort()
  }


}
//排序 報名班級資料
function signUpTableDataSort(){
  // 打開報名班級的視窗
  dialogAddClassCtrl.value = true;
  // 判斷是否為中文（根據 Unicode）
  const isChinese = (text) => /[\u4e00-\u9fff]/.test(text);
  applyTableData.value.sort((a, b) => {
    const aHasGroup = a.groupId.some((id) => id.toString().trim() !== "");
    const bHasGroup = b.groupId.some((id) => id.toString().trim() !== "");

    if (bHasGroup !== aHasGroup) {
      return bHasGroup - aHasGroup; // `groupId` 有值的排前面
    }

    const aIsChinese = isChinese(a.name);
    const bIsChinese = isChinese(b.name);

    if (aIsChinese !== bIsChinese) {
      return aIsChinese - bIsChinese; // 英文優先
    }

    return a.name.localeCompare(b.name, "zh-Hant"); // 中文用筆畫，英文用字母排序
  });
}

// function DownLoadFun(url){//簡章下載程式碼  
//   console.log('DownLoadFun簡章下載function');
//   const link = document.createElement('a');
//   link.href = url;
//   debugger
//   link.download = url.substring(url.lastIndexOf('/') + 1); // 可以設定為你希望的文件名
//   link.click();
// }
//點選按鈕的function↑↑


//跳轉IES5
function gotoTeammodel(target){
  if (tmdid.value !== "" && sessionStorage.getItem("id_token")) {
    // 先用帳密取id_token
    let data = {
      grant_type: "code",
      client_id: clientID,
      nonce: "0",
      id_token: sessionStorage.getItem("id_token")       
    }
    post(coreAPIUrl + '/oauth2/login', data).then(async res => {
      if (res && res.code) {
        let urlhost = api.main.geties5ApiUrl();        

        let websirtPart2 = urlhost + '/login/?code=' + res.code + '&identity=teacher&target=' + target;
        window.open(websirtPart2, '_blank');
      } 
    })
  } else {
    ElMessage({
      type: 'error',
      message: t('AccountLogin.enterAccountAndPassword'),
    })
  }
}

// 設定學校送出
// eslint-disable-next-line no-unused-vars
function setSchoolsubmit(){
  
  if (selectedSchool.value) {// 有登入而且有選擇學校
    
    // 取學校地理資訊
    const options = cascaderOptions.value
    const [countryId, cityId] = selectedLocation.value
    // 找到國家
    const country = options.find(c => c.value === countryId)
    if (!country) return null
    // 找到城市
    const city = country.children?.find(c => c.value === cityId)
    if (!city) return null
    // 找到地區    

    let schoolItem = optionsSchool.find(item => item.code === selectedSchool.value);
       
    userSchool.value.schoolId = schoolItem.code;
    userSchool.value.schoolName = schoolItem.name;
    userSchool.value.schoolUnitType = schoolItem.type;
    userSchool.value.schoolCountryId = countryId.value;
    userSchool.value.schoolCountryName = country.label;
    userSchool.value.schoolProvinceId = "";
    userSchool.value.schoolProvinceName = "";
    userSchool.value.schoolCityId = cityId.value;
    userSchool.value.schoolCityName = city.label;    

    
    
    // 1. 從 "我要報名" 進入 => 沒報名過
    // 2. 從 "編輯學校進入"  => 有報名過

    if (!isJoin.value)  {// 沒報名過      
      if (!userSchoolRowData.tmidInfo.schoolCode) {
        // 有無設定過學校
        // 沒有進階資訊學校資料 要寫進階資訊

        // 存進階資訊學校
        let data = {
          name: sessionStorage.getItem("open_name"),
          grant_type: "add",
          id_token: sessionStorage.getItem("id_token"),
          lang: "zh-tw",
          schoolCode: selectedSchool.value,
          unitType: schoolItem.type,
          unitName: schoolItem.name,
          mail: userSchool.value.mail
        }

        post(coreAPIUrl + '/oauth2/Contact', data).then(async res => {
          if (res && res.status && res.status === 200) {
            selectedSchool.value = '';
            selectedLocation.value = '';            
            // 重新走我要報名流程
            BtnFunction('join', true)
          }
        })

      } else {
        // 有學校資料 不要寫進階資訊      
        // 直接走我要報名流程
        BtnFunction('join', true)
      }
    } else {
      // 有報名過 直接關閉視窗
      selectedSchool.value = '';
      selectedLocation.value = '';
    }
    dialogSetSchoolCtrl.value = false;



  } else {
    ElMessage({
      type: 'error',
      message: '請選擇學校',
    })
  }

}

function getGroupName(groupId){
  let group = groupListInfo.find(item => item.id === groupId);
  return group ? group.name : '';
}
// 打開報名視窗
function openSelectItem(rowItem){
  dialogSignUpCtrl.value = true;
  selectedRow.value = JSON.parse(JSON.stringify(rowItem));

}
// 取消確認視窗
const cancelConfirm = (rowItem) => {
  ElMessageBox.confirm(
    '確定要取消報名？',
    '取消報名',
    {
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      type: 'warning',
      icon: markRaw(Delete),
    }
  )
    .then(() => {
      dialogAddClassConfirm(rowItem)
      ElMessage({
        type: 'success',
        message: '報名已取消',
      })
    })
    .catch(() => {      
    })
}

// eslint-disable-next-line no-unused-vars
function goModifySchool(){
  dialogSetSchoolCtrl.value = true;
   // 優先使用 joinSchool[0] 的資料，如果沒有則使用 tmidInfo
  const schoolData = userSchoolRowData.joinSchool && userSchoolRowData.joinSchool.length > 0 
    ? userSchoolRowData.joinSchool[0] 
    : userSchoolRowData.tmidInfo;

   if (schoolData) {
    // 確保 cascaderOptions 已經有值
    if (!cascaderOptions.value) {
      ElMessage.error('無法取得地區資訊');
      return;
    }  

    // 設定 el-cascader 的值 (確保是字串格式)
    selectedLocation.value = [
      String(schoolData.schoolCountryId),
      String(schoolData.schoolCityId)
    ].filter(Boolean);
    
    // 呼叫 API 取得學校列表
    const data = {
      countryId: schoolData.schoolCountryId,
      cityId: schoolData.schoolCityId
    };

    // 取得學校列表後設定 el-select 的值
    post(coreAPIUrl + '/service/schoolData', data).then(res => {
      optionsSchool.length = 0;
      res.forEach((item) => {
        optionsSchool.push(item);
      });
      
      // 設定選中的學校 (確保是字串格式)
      selectedSchool.value = String(schoolData.schoolId || schoolData.schoolCode);
    });
  }

}
</script>


<style lang="less" scoped>
@fontColor: #424f55;
@fontColor-light: #8da3a0;
@stressColor: #f59f56;
@fontColor-gray1: #909399;
@fontColor-gray2: #b1b3b8;
@other-blue: #70a6b2;
@background-gray: #eff4f7;

// Loading 覆蓋層
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
  p {
    margin-top: 20px;
    font-size: 16px;
    color: @fontColor;
  }
}

// 表單容器
.form-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 30px;
}

.signup-form-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0;
  width: 100%;
}

.signup-info-group {
  background: #f5f9ff;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.signup-field-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.signup-field-label {
  font-size: 13px;
  color: #888;
  white-space: nowrap;
  min-width: 110px;
}

.signup-field-value {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  word-break: break-all;
}

.form-item {
  margin-bottom: 28px;
  font-size: 16px;
}

.form-item strong {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
}

.input-email {
  margin-bottom: 5px;
}

.input-width {
  width: 80%;
}

/deep/.el-cascader.input-width {
  width: 80%;
}

.spanTotal {
  border-right: solid;
  margin-right: 15px;
  border-color: lightgrey;
}

.spanTotal2 {
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  align-items: flex-end;
  display: flex;
}

.signup-dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

// /deep/ .el-dialog__header.show-close {
//   padding-right: 0px !important;
// }

/deep/ .el-dialog.login-dialog {
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  background-color: #fff;
}

.login-dialog-header {
  padding: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  border-bottom: solid;
  border-color: gainsboro;
}

.login-dialog-content {
  margin-top: 20px;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #444;
}

.title_school {
  font-weight: bold;
  font-size: 25px;
  margin-top: auto;
}

.a_color {
  color: @stressColor;
  cursor: pointer;
}

.otheBlueColor {
  color: @other-blue;
}

.stressColor {
  color: @stressColor;
}

.gray1Color {
  color: @fontColor-gray1;
}

.highlight-row {
  background-color: #fef0f0;
  color: #f56c6c;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 10px;
  font-size: 12px;
}

.current_progress {
  color: @stressColor;
  font-size: 12px;
  background: #fff3e0;
  padding: 2px 8px;
  border-radius: 4px;
}

// 活動資訊區域
.ActiveAllInfo {
  position: relative;
  margin-top: 10px;

  .ActiveTitle {
    font-size: 70px;
    margin-bottom: 10px;

    &.PC {
      font-size: 37px;
    }
  }

  .ActiveInfoDiv {
    margin-top: 10px;

    @media (max-width: 1250px) {
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .ActivePic {
      width: 250px;
      height: 250px;

      .pic {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .titleContentArea {
      margin-left: 20px;

      .otherInfoArea {
        flex: 1;
        min-width: 250px;
        max-width: 300px;
        margin-bottom: 20px;

        .Replenish {
          color: @fontColor-gray1;
          font-style: oblique;
        }

        @media (max-width: 1090px) {
          margin: 50px 20px;
        }
      }
    }
  }
}

// 按鈕區域
.joinButtonArea {
  margin-top: 30px;

  .joinButton {
    align-items: center;
    border-radius: 50px;
    font-size: 20px;
    font-weight: bold;
    width: 200px;
    height: 50px;
    background: @fontColor-gray1;
    cursor: no-drop;
    display: flex;
    justify-content: center;
    align-items: center;

    .txt {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &.downLoad {
      background-color: @other-blue;

      &.load {
        cursor: pointer;
      }

      &.PC {
        margin-right: 20px;
      }
    }

    &.mar-right {
      &.PC {
        margin-right: 20px;
      }
    }

    &.onClick {
      background: @stressColor;
      cursor: pointer;
    }

    &.disabled {
      background: #ccc;
      color: #666;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
}

// 內容區域
.cotentDiv {
  max-width: 1200px;
  width: 100%;
  padding: 20px;
}

.tableDiv {   
  width: 90%;
  max-width: 1200px;
  margin-top: 50px;
  
  .info {
    display: flex;
    align-items: end;
  }
  
  &.class {
    margin-bottom: 50px;
  }
  
  &.planDiv {
    margin-bottom: 100px;
  }
  
  ::v-deep .info-cell {
    white-space: normal;
    word-wrap: break-word;
    text-align: left;
  }
  
  .titleDiv {
    margin-bottom: 10px;
    
    .title {
      font-weight: bold;
      font-size: 25px;
      text-decoration: underline;
      margin-top: auto;
      
      .iconPic {
        width: 50px;
        margin-right: 10px;
      }
    }
  }
  
  &.left {
    flex: 1;
  }
  
  &.right {
    width: 100%;
    margin-left: 0px;
  }
}

.titleDiv {
  margin-bottom: 15px;
  
  .title {
    font-size: 18px;
    font-weight: bold;
    color: @fontColor;
    
    .iconPic {
      width: 24px;
      //height: 24px;
      margin-right: 8px;
    }
  }
}

// 得獎區域
.winCotent {
  margin-top: 20px;
  
  .ContestTitle {
    font-size: 16px;
    font-weight: bold;
    color: @fontColor;
    margin-bottom: 10px;
    padding: 8px 16px;
    background: #f5f7fa;
    border-radius: 4px;
  }
}

.tableCss, .tableCssPhone {
  margin-bottom: 15px;
}

.winTxt {
  margin-left: 8px;
  font-weight: 600;
}

// 學校列表
.schoolList {
  .list {
    padding: 8px 0;
    font-size: 16px;
    
    .iconPic {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}

// 表單提醒
.award-form-notice-pc,
.award-form-notice-mobile {
  background: #fff3e0;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 800px;
  
  .form-link-decoration {
    font-size: 24px;
  }
}

// 時程區域
.scheduleArea {
  margin-bottom: 20px;
  
  .titleArea {
    margin-bottom: 10px;
    
    .stepName {
      font-size: 18px;
      font-weight: bold;
    }
  }
  
  .card {
    background: #f5f7fa;
    padding: 15px;
    border-radius: 8px;
    
    .place, .time {
      margin-bottom: 8px;
    }
    
    .description {
      color: @fontColor-gray1;
    }
  }
  
  .triangleArea {
    padding: 10px 0;
    
    .triangle {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 15px solid @other-blue;
    }
  }
}

// 頁尾
.footerDiv {
  background: @background-gray;
  padding: 30px;
  margin-top: 40px;
  
  .txtDiv {
    max-width: 1200px;
    line-height: 1.8;
    font-size: 14px;
    color: @fontColor-gray1;
  }
  
  &.phone {
    padding: 20px;
    
    .txtDiv {
      font-size: 12px;
    }
  }
}

// 對話框
.dialog-header {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  margin-left: -24px;
  margin-right: -24px;
  padding-left: 24px;
  padding-right: 24px;
  //border-bottom: 2px solid #f0d9bc;
  
  .iconPic {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  
  .title {
    font-size: 18px;
    font-weight: bold;
  }
}

.applyTableDiv {
  .content {
    padding: 20px;
    
    .info {
      background: #d6eaf8;
      padding: 15px;
      border-radius: 8px;
      margin-bottom: 20px;
      line-height: 1.8;
      border-left: 4px solid #2e86c1;
    }
    
    .school-header {
      // background: #ebf5fb;
      margin-bottom: 15px;
      padding: 12px;
      border-radius: 8px;
      // border: 1px solid #a9cce3;
      
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #424f55;
      }
      
      .editButton {
        margin-left: 10px;
      }
    }
    
    .chooseArea2 {
      background: #f5f9ff;
      margin-bottom: 15px;
      padding: 12px;
      border-radius: 8px;
    }
  }
}

// 通用類別
.div-center{/*水平置中*/
  display: flex; 
  justify-content: center; 
  text-align:center;
  width:100%;
}
.div-center2{
  margin-right: auto;
  margin-left: auto;
}
.div-centerY{ /*垂直置中*/
  display: flex;    
  align-items: center;
  flex-direction: column;  //有時可能需要在加這個屬性
  &.YUnset{
    flex-direction: unset;  
  }
}
.div-centerY2{ /*垂直置中*/
  margin-top: auto;
  margin-bottom: auto;
}

.oneLine {
  display: flex;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left {
  text-align: left;
}

.cursorPointer {
  cursor: pointer;
}

.whiteColor {
  color: white;
}

.picButton {
  position: relative;
  cursor: pointer;
  margin-top: 10px;
  width: 200px;
  height: 35px;

  &.big {
    width: 200px;
    height: 50px;
  }

  .buttonImg {
    height: 100%;
    width: 100%;
    display: block;
  }

  .pngText {
    font-size: 16px;

    &.big {
      font-size: 20px;
    }

    transform: translate(0%, -130%);
    color: white;
    font-weight: bold;
    text-align: end;
  }

  .txt {
    font-size: 20px;
    font-weight: bold;
  }
}

.signUpButton {
  background: @stressColor;
  border-color: @stressColor;
  color: white;
}

.urlCss {  
  color: #409EFF;
  font-weight: bold;
  text-decoration: none;
  transition: 0.3s;
}

.line {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}

// 表格背景
/deep/ .tableBackground {
  background-color: #fff8e1 !important;
}

// 普通表格樣式
.scheduleTable {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  
  thead {
    background-color: transparent;
  }
  
  th {
    color: #999;
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #999;
    font-weight: bold;
    font-size: larger;
  }
  
  td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #999;
  }
  
  tbody tr {
    &:hover {
      background-color: #f5f7fa;
    }
  }
  
  tbody tr.highlight-row {
    background-color: #F59F56;
    color: #fff;
  }
}

// RWD
@media (max-width: 768px) {
  .cotentDiv {
    padding: 10px;
  }
}

</style>

<style lang="less">

// ──────────────────────────────────────────────
// 純 HTML 卡片風格列表 (對話框內使用)
// ──────────────────────────────────────────────
.cardListContainer {
  width: 100%;
  overflow-y: auto;
  max-height: 400px;
  padding: 0;
  position: relative;
}

.cardListHeader {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr 1fr 1.8fr;
  gap: 16px;
  padding: 16px 20px;
  background: transparent;
  margin-bottom: 12px;
  position: sticky;
  top: 0;
  z-index: 20;
  font-weight: 700;
  font-size: 13px;
  color: #666;
  text-align: left;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #eee;
}

.cardListBody {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cardListContainer.hide-edit-column .cardListHeader,
.cardListContainer.hide-edit-column .cardRow {
  grid-template-columns: 2fr 1fr 1fr 1fr 1.8fr;
}

.cardRow {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr 1fr 1.8fr;
  gap: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
  align-items: center;
}

.cardRow:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.cardColumn {
  display: flex;
  align-items: center;
  gap: 8px;
}

.class-manage-card-list .cardListHeader {
  font-size: 14px;
}

.class-manage-card-list .cardRow {
  font-size: 15px;
}

.class-manage-card-list .btn {
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 999px !important;
}

.class-manage-card-list .col-edit .el-button {
  border-radius: 999px;
}

// 按鈕樣式 (純 HTML 按鈕替代 el-button)
.btn {
  padding: 4px 10px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.btn-primary {
  background: #3a90d4;
  color: white;
}

.btn-primary:hover {
  background: #2970be;
}

.btn-secondary {
  background: #e6a23c;
  color: white;
}

.btn-secondary:hover {
  background: #cc8f1f;
}

.btn-warning {
  background: #f59f56;
  color: white;
}

.btn-warning:hover {
  background: #e07d3e;
}

.btn-danger {
  background: #f56c6c;
  color: white;
}

.btn-danger:hover {
  background: #f04c4c;
}

.btn-small {
  padding: 4px 8px;
  font-size: 11px;
}

// ──────────────────────────────────────────────
// 班級管理對話框預設樣式 (溫暖奶茶米白)
// ──────────────────────────────────────────────

.applyTableDiv {  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(66,79,85,0.14) !important;

  .el-dialog__header {
    background: transparent;
    padding: 16px 24px;
    .title {
      color: #424f55;
      font-size: 18px;
      font-weight: 700;
    }
    .el-dialog__headerbtn .el-icon { color: #f59f56 !important; }
  }

  .content .info {
    background: #d6eaf8;
    border-left: 4px solid #2e86c1;
    border-radius: 8px;
    color: #424f55;
    font-size: 14px;
  }

  .school-header .title { color: #424f55; font-size: 20px; font-weight: 700; }



  .class-dialog-full-underline {
    position: relative;
  }

  .class-dialog-full-underline::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: #f5c98b;
    border-radius: 2px;
  }

  .class-create-dialog-header.dialog-header {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
  }


  .chooseArea2 > div > span {
    background: #fdecd6 !important;
    color: #424f55 !important;
    padding: 3px 14px;
    border-radius: 6px;
    font-weight: 600;
    border: 1px solid #f5c98b;
  }

  .cardListHeader {
    background: #fae6cb !important;
    color: #424f55 !important;
  }

  .chooseArea2 .el-button--primary,
  .btn-primary {
    background: #f59f56 !important;
    border: none !important;
    border-radius: 6px;
    font-weight: 600;
  }

  .highlight-row {
    background: #d8edf0 !important;
    color: #2f7580 !important;
    border: 1px solid #9dcbd2;
    border-radius: 5px;
  }

  .btn-action-edit {
    background: #84c2ba !important;
    color: #fff !important;
  }

  .btn-action-edit:hover {
    background: #6ba59e !important;
  }

  .btn-action-cancel {
    background: #f58f8f !important;
    color: #fff !important;
  }

  .btn-action-cancel:hover {
    background: #ef7a7a !important;
  }

  .btn-action-signup {
    background: #61a8df !important;
    color: #fff !important;
  }

  .btn-action-signup:hover {
    background: #4f95cb !important;
  }
}

// 報名視窗：強制 body 撐滿寬（因 div-centerY 的 align-items:center 會收縮子元素）
.signup-dialog .el-dialog__body {
  width: 80%;
  box-sizing: border-box;
}

.create-class-dialog .el-dialog__header {
  width: 100%;
  box-sizing: border-box;
}

// ──────────────────────────────────────────────
// 新增/變更班級 步驟式佈局
// ──────────────────────────────────────────────
.createClass-step {
  width: 100%;
  margin-bottom: 18px;
}

.createClass-step-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #2e86c1;
  margin-bottom: 10px;
  border-bottom: 2px solid #d6eaf8;
  padding-bottom: 8px;
  width: 100%;
}

.step-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: #2e86c1;
  color: #fff;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.createClass-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.createClass-course-tag {
  background: #2e86c1;
  color: #fff;
  padding: 4px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.createClass-dash {
  color: #888;
  font-size: 18px;
}

.createClass-hint-body {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}

.createClass-hint-text {
  flex: 1;
  font-size: 14px;
  line-height: 2;
  color: #424f55;
}

.createClass-hint-img {
  flex-shrink: 0;
  position: relative;
}

.hint-img-zoom {
  cursor: zoom-in;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  transform-origin: center center;
}

.hint-img-zoom:hover {
  transform: scale(2.8);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  z-index: 100;
  position: relative;
}

.createClass-editor {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 10px;
}

.createClass-editor-col {
  flex: 1;
}

.createClass-col-label {
  font-size: 13px;
  font-weight: 600;
  color: #2e86c1;
  margin-bottom: 6px;
}

.createClass-editor-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.createClass-add-btn {
  white-space: nowrap;
  font-size: 13px;
  padding: 8px 14px;
}

</style>
